import { useMontagemEstabilizacao } from './apresentacao/useMontagemEstabilizacao'
import { PainelMontagemEstabilizacao } from './apresentacao/PainelMontagemEstabilizacao'
import { estadosDaEtapaAnatomia, pecaPresenteNoPerfil, prepararPecaAnatomia } from './dominio/didatico/exploracaoAnatomia'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { carregarCenarioMvp } from './dados/carregarCenario'
import { acoesDisponiveis, componenteDidatico, resolverSelecao } from './dominio/didatico/catalogo'
import { comAcao, estadoDe, restaurarTudo, rotuloAcao, type AcaoPeca, type MapaEstados } from './dominio/didatico/estadoPecas'
import { PERFIS_VEICULO, perfilVeiculoPorId, srsAtivos, type PerfilVeiculo } from './dominio/didatico/perfilVeiculo'
import { IDS_PERFIL_VITIMA, perfilVitimaPorId } from './dominio/didatico/perfisVitima'
import { aberturaPorId, aberturasDeSaida } from './dominio/didatico/aberturas'
import { IDS_PROCEDIMENTO, PROCEDIMENTOS } from './dominio/didatico/procedimentosInternos'
import { acessoTraseiroNoTempo, estadosDoAcessoTraseiro } from './dominio/didatico/acessoTraseiro'
import { folgaMinima, folgaVerticalNoTeto, obstaculosDaRota } from './dominio/didatico/obstaculosRota'
import { custoDoGiro } from './dominio/didatico/custoDoGiro'
import { efeitoGeometricoDaAcao } from './dominio/didatico/efeitoAcao'
import { idsDoBanco } from './dominio/didatico/bancos'
import {
  ANGULOS_NOMINAIS,
  construirRota,
  construirRotaDirecional,
  construirRotaLivre,
  construirRotaPorAbertura,
  ladoNominalDaAncora,
  amostrarRota,
  leituraDaRota,
  marcosDaRetirada,
  type AnguloNominal,
} from './dominio/didatico/rotasExtracao'
import { POSE_ALINHADA, POSE_SENTADA, eixoColunaDaVitima } from './dominio/didatico/rigVitima'
import {
  colocacaoNaConfiguracao,
  direcaoElevacaoPaDeForno,
  vitimaDeitada,
  type ConfiguracaoVeiculo,
  type Decubito,
  type SentidoCabeca,
} from './dominio/didatico/configuracaoVeiculo'
import { ancoraPorId, sufixoAncora } from './dominio/didatico/perfilVeiculo'
import {
  estadosDaTecnica,
  ganhoDeEspaco,
  perfilComTeto,
  tecnicaDeTeto,
  type EstadoTeto,
} from './dominio/didatico/teto'
import {
  amostrarCinematica,
  colisao,
  type TipoColisao,
} from './dominio/didatico/timelineCinematica'
import {
  ID_OCUPANTE_PADRAO,
  OCUPANTES_PADRAO,
  adicionar as adicionarOcupanteNaLista,
  comRetencao,
  comEstadoClinico,
  ocupantePorId,
  pessoas,
  vitimasPorPrioridade,
  vitimaInterfereNaTrajetoria,
  remover as removerOcupanteDaLista,
  type Ocupante,
  type EstadoClinico,
} from './dominio/didatico/ocupantes'
import { reacaoDoOcupante, type ModoRetencao } from './dominio/didatico/retencaoOcupante'
import type { TonusOcupante } from './dominio/didatico/tonusOcupante'
import { origemDeContatoPadrao, superficiesDoHabitaculo } from './dominio/didatico/superficiesInternas'
import {
  estadosDosProcedimentos,
  feitosAntesDaUltimaAlternancia,
  PROCEDIMENTOS_DO_BANCO,
  type IdProcedimento,
} from './dominio/didatico/procedimentosInternos'
import { SETA_NEUTRA, orientacaoDaRota, type OrientacaoSeta } from './dominio/didatico/setaCervical'
import type { Cenario } from './dominio/modelos/cenario'
import { ControlesTimeline } from './apresentacao/ControlesTimeline'
import { CentralLogs, type RegistroSimulacao } from './apresentacao/CentralLogs'
import { TelaCarregamento } from './apresentacao/TelaCarregamento'
import { Legenda, PainelCamadas } from './apresentacao/PainelCamadas'
import { PainelCinematica, type SecaoPainelCinematica } from './apresentacao/PainelCinematica'
import { PainelQuatroImpactos } from './apresentacao/cinematica/PainelQuatroImpactos'
import { calcularDeltaV } from './dominio/didatico/metricasCinematica'
import { obterPistasAtivas, pistaPorId } from './dominio/didatico/pistasCena'
import type { LadoImpactoLateral, TrajetoriaFrontal } from './dominio/didatico/variacoesCinematica'
import {
  CONFIGURACAO_OUTRO_VEICULO_PADRAO,
  type ConfiguracaoOutroVeiculo,
} from './dominio/didatico/colisaoEntreVeiculos'
import { deformacaoDoEvento } from './dominio/didatico/deformacaoDoEvento'
import { alvoEfetivo } from './dominio/didatico/tiposDeImpacto'
import { exportarColisaoParaOficina } from './dominio/didatico/modoInvestigador'
import type { HitVeiculo } from './dominio/didatico/inspecaoVeicular'
import { PainelManejoVidros, type SecaoPainelManejoVidros } from './apresentacao/PainelManejoVidros'
import { CATALOGO as CATALOGO_TABLETOP, PainelTabletop, type SecaoPainelTabletop } from './apresentacao/PainelTabletop'
import { PainelMesaTabletop } from './apresentacao/tabletop/PainelMesaTabletop'
import { TelaProjecaoTabletop } from './apresentacao/tabletop/TelaProjecaoTabletop'
import { ehJanelaDeProjecao } from './apresentacao/tabletop/canalProjecaoTabletop'
import { type CinematicaFichaVitima } from './dominio/tabletop/atendimento'
import { obterCenarioDidaticoPorId } from './dominio/tabletop/cenariosDidaticos'
import { OperacoesVeiculo } from './apresentacao/tabletop/atendimento/OperacoesVeiculo'
import { useOperacoesSessao } from './apresentacao/tabletop/useOperacoesSessao'
import { usePersistenciaSessao } from './apresentacao/tabletop/usePersistenciaSessao'
import { BarraAcaoRapidaSelecao } from './apresentacao/tabletop/BarraAcaoRapidaSelecao'
import { useAtendimentoTabletop } from './apresentacao/tabletop/useAtendimentoTabletop'
import { PainelEstabilizacao, type SecaoPainelEstabilizacao } from './apresentacao/PainelEstabilizacao'
import type { FisicaCarga } from './fisica/useFisicaCarga'
import { PainelDetalhes } from './apresentacao/PainelDetalhes'
import { PainelAnatomia } from './apresentacao/PainelAnatomia'
import { PainelExtracao, type ModoRota, type SecaoPainelExtracao } from './apresentacao/PainelExtracao'
import { OficinaVitimas, useEstadoOficinaVitimas } from './apresentacao/extracao/OficinaVitimas'
import { PainelDecisaoExtracao } from './apresentacao/PainelDecisaoExtracao'
import { PainelOcupantes } from './apresentacao/PainelOcupantes'
import { PainelProcedimentos } from './apresentacao/PainelProcedimentos'
import { PainelAutoriaCenario } from './apresentacao/PainelAutoriaCenario'
import {
  PainelOficinaCorte,
  type ConfiguracaoOficinaCorte,
  type FerramentaOficinaCorte,
  type ModoOficinaCorte,
  type PecaOficinaCorte,
  type SecaoPainelOficinaCorte,
} from './apresentacao/PainelOficinaCorte'
import { usePlayerOficinaCorte } from './apresentacao/oficina/usePlayerOficinaCorte'
import type { IdZonaTetoLateral } from './dominio/didatico/rebatimentoLateralTeto'
import type { IdZonaElevacaoPainel } from './dominio/didatico/elevacaoPainel'
import type { IdZonaRebatimentoPainel } from './dominio/didatico/rebatimentoPainel'
import type { EtapaDemonstracaoCorte, TecnicaCorte } from './dominio/didatico/tecnicasCorteCatalogo'
import {
  BarraFerramentasCenario,
} from './apresentacao/ribbon/BarraFerramentasCenario'
import {
  IconeAdicionar,
  IconeAlinhamentoVitimaPrancha,
  IconeBloco,
  IconeCalco,
  IconeCunha,
  IconeDesfazer,
  IconeFerramenta,
  IconeFitaCatraca,
  IconeInteriorExtracao,
  IconePausar,
  IconePerturbar,
  IconeRefazer,
  IconeReiniciar,
  IconeReproduzir,
  IconePonto,
  IconeRestaurar,
  IconeRetirarPeca,
  IconeSelecao,
  IconeSustentarPeca,
  IconeVidro,
  IconeVStrut,
  IconeVoltarEnquadramento,
} from './apresentacao/icones'
import { BarraAplicacao } from './apresentacao/workspace/BarraAplicacao'
import { BarraEstado, type ItemEstado } from './apresentacao/workspace/BarraEstado'
import { Workspace } from './apresentacao/workspace/Workspace'
import { MODULOS, moduloPorId, type IdModulo } from './apresentacao/workspace/modulos'
import { DockMobile } from './apresentacao/workspace/DockMobile'
import { Inspetor } from './apresentacao/workspace/Inspetor'
import { DockCamera3D } from './apresentacao/workspace/DockCamera3D'
import { InspetorCAD } from './apresentacao/workspace/InspetorCAD'
import { GuiaRapidoExtracao } from './apresentacao/extracao/GuiaRapidoExtracao'
import { TrilhaFerramentas, type Ferramenta as FerramentaDaTrilha } from './apresentacao/workspace/TrilhaFerramentas'
import { ferramentasCinematica } from './apresentacao/modulos/cinematicaTools'
import { ferramentasEstabilizacao } from './apresentacao/modulos/estabilizacaoTools'
import { ferramentasEstrutura } from './apresentacao/modulos/estruturaTools'
import { ferramentasExtracao } from './apresentacao/modulos/extracaoTools'
import { ferramentasTabletop } from './apresentacao/modulos/tabletopTools'
import { ferramentasCorte } from './apresentacao/modulos/corteTools'
import {
  ATALHO_MODO_ALARGADOR,
  EQUIPAMENTOS_DE_APOIO,
  FERRAMENTAS_DE_INTERVENCAO,
  MODOS_DO_ALARGADOR,
  MOTIVO_EQUIPAMENTO_DE_APOIO,
  ferramentaDaCaixa,
  ferramentaPorAtalho,
} from './apresentacao/oficina/ferramentasOficina'
import type { FerramentasModulo } from './apresentacao/modulos/tipos'
import { useModoLayout } from './apresentacao/workspace/useModoLayout'
import { useControleCamera } from './visualizacao3d/camera/comandosCamera'
import { MODOS_MAQUETE, PRESET_CONCEITO, PRESETS } from './apresentacao/presetsModo'
import { useTimeline } from './apresentacao/useTimeline'
import { Visualizador3D } from './visualizacao3d/Visualizador3D'
import type { Camadas, ModoVisualizacao } from './visualizacao3d/componentes/contextoMaquete'
import type { TipoAlvoImpacto } from './dominio/didatico/alvosImpacto'
import {
  avaliarColocacoes,
  EQUIPAMENTOS_ESTABILIZACAO,
  type ColocacaoEquipamento,
  type EquipamentoEstabilizacao,
  type PontoSolo,
  type PosicaoEstabilizacao,
} from './dominio/didatico/estabilizacao'

export type FerramentaEstabilizacao = 'selecao' | EquipamentoEstabilizacao
import {
  atualizarSuspensao,
  DURACAO_PERTURBACAO_QUATRO_CANTOS_MS,
  ESTADO_SUSPENSAO_INICIAL,
  SEQUENCIA_PERTURBACAO_QUATRO_CANTOS,
  type EstadoSuspensao,
  type ForcaPerturbacao,
} from './dominio/didatico/suspensaoVeiculo'
import {
  CATALOGO_VIDROS,
  executarManejoVidro,
  removerPeliculaCraquelada,
  PROTECOES_INICIAIS,
  type EstadoManejoVidro,
  type FerramentaVidro,
  type IdVidro,
  type ProtecoesManejo,
  type ResultadoAcaoVidro,
} from './dominio/didatico/manejoVidros'
import type { Vetor3 } from './dominio/geometria/vetor3'
import {
  obstaculosQueInterferem,
  type ObstaculoExterno,
  type TipoObstaculoExterno,
} from './dominio/didatico/obstaculosExternos'
import type { FerramentaExtracao } from './visualizacao3d/extracao/CenaExtracao'
import { etapaAnatomiaPorId, type EtapaAnatomia } from './dominio/didatico/roteiroAnatomia'
import {
  vinculosRestantes,
  type IdZonaOperacaoPorta,
} from './dominio/didatico/oficinaCorte'
import type { IdPortaOficina } from './visualizacao3d/oficina/zonasOperacaoPorta'
import type { IdZonaOperacaoTampa } from './dominio/didatico/oficinaPortaMalas'
import type { IdZonaOperacaoTerceiraPorta } from './dominio/didatico/oficinaTerceiraPorta'
import type { IdLadoTerceiraPorta } from './visualizacao3d/oficina/zonasOperacaoTerceiraPorta'
import {
  useSessaoOficinaCorte,
  type InstantaneoHistoricoOficina,
} from './apresentacao/oficina/useSessaoOficinaCorte'
import type { TipoEstruturaVeicular } from './dominio/didatico/tiposEstruturaVeicular'
import { useTabletop } from './apresentacao/tabletop/useTabletop'
import { useHistoricoDeModulo, type ControleHistorico } from './apresentacao/useHistoricoDeModulo'
import { useSessaoExtracao } from './apresentacao/useSessaoExtracao'
import { useCenariosAutorais } from './apresentacao/useCenariosAutorais'
import { CENARIOS_EXTRACAO, cenarioExtracaoPorId, ocupantesDoCenario } from './dominio/didatico/cenariosExtracao'
import { achadosComRegiaoVisiveis, aprisionamentosVisiveis, vitimaSeveridadeVisivel } from './dominio/didatico/sessaoExtracao'

/** mm:ss do tempo simulado, para o aviso de sessão salva. */
function formatarTempoAula(segundos: number): string {
  return `${Math.floor(segundos / 60).toString().padStart(2, '0')}:${(segundos % 60).toString().padStart(2, '0')}`
}

/** Alias histórico: o módulo ativo. A tabela dos seis vive em `workspace/modulos`. */
type Aba = IdModulo

const TITULOS: Record<Aba, string> = Object.fromEntries(
  MODULOS.map((modulo) => [modulo.id, modulo.titulo]),
) as Record<Aba, string>

/** Duração da deflagração didática na Anatomia. */
const DURACAO_DEFLAGRACAO_ANATOMIA_MS = 600

export default function App() {
  const [cenario, setCenario] = useState<Cenario | null>(null)
  const [erro, setErro] = useState<string | null>(null)

  const [aba, setAba] = useState<Aba>('maquete')
  /** De onde veio um pulo para a Cinemática (ex.: "Ver cinemática desta vítima" da Oficina) — só existe quando o pulo foi assim, nunca num clique direto na aba. Alimenta o botão "Voltar". */
  const [moduloCinematicaOrigem, setModuloCinematicaOrigem] = useState<Aba | null>(null)
  const [mostrarQuatroImpactos, setMostrarQuatroImpactos] = useState(false)
  const mostrarCenaGuiada = mostrarQuatroImpactos
  const [tema, setTema] = useState<'claro' | 'escuro'>(() => {
    if (typeof window === 'undefined') return 'escuro'
    return window.localStorage.getItem('csv-lab-tema') === 'claro' ? 'claro' : 'escuro'
  })
  const modoLayout = useModoLayout()
  const camera = useControleCamera()
  /* O inspetor abre sozinho quando algo é selecionado. Recolher é escolha do
     usuário e vale só até a seleção mudar — senão ele "some" e o aluno não
     entende por quê. */
  const [inspetorRecolhido, setInspetorRecolhido] = useState(false)
  const [grupoRibbonAtivo, setGrupoRibbonAtivo] = useState<string | null>(null)
  const [abaInspetorCAD, setAbaInspetorCAD] = useState<'operacao' | 'propriedades' | 'checklist'>('operacao')
  const [modo, setModo] = useState<ModoVisualizacao>('estrutura')
  const [camadas, setCamadas] = useState<Camadas>(PRESETS.estrutura.camadas)
  const [opacidadeCarroceria, setOpacidadeCarroceria] = useState(PRESETS.estrutura.opacidadeCarroceria)
  const [mostrarRotulos, setMostrarRotulos] = useState(PRESETS.estrutura.mostrarRotulos)
  /**
   * Pintura da estrutura pela classe de aço.
   *
   * Fica fora de `camadas` e fora dos presets de modo: não é uma peça a mais na
   * cena, é a mesma cena respondendo a outra pergunta. Começa desligada porque
   * a aula de anatomia é sobre onde a peça fica, e a de corte é sobre do que
   * ela é feita — são momentos diferentes.
   */
  const [pinturaPorAco, setPinturaPorAco] = useState(false)

  const tabletop = useTabletop({ mesaCompartilhada: true })
  const [cenarioDidaticoId, setCenarioDidaticoId] = useState<string>('cenario-1')
  const [secaoTabletop, setSecaoTabletop] = useState<'cenario' | 'vitima' | 'corte' | 'estabilizacao'>('cenario')

  const carregarCenarioDidatico = useCallback((idCenario: string) => {
    tabletop.cancelarPosicionamento()
    setCenarioDidaticoId(idCenario)
    tabletop.carregarExemplo(idCenario)
  }, [tabletop])

  useEffect(() => {
    tabletop.cancelarPosicionamento()
  }, [tabletop.modo, cenarioDidaticoId])

  useEffect(() => {
    if (aba !== 'tabletop') tabletop.cancelarOlharPara()
  }, [aba, tabletop.cancelarOlharPara])

  const [encaixeTabletopAtivo, setEncaixeTabletopAtivo] = useState(false)
  const [pincelTabletopAtivo, setPincelTabletopAtivo] = useState(false)
  const [larguraPincelTabletop, setLarguraPincelTabletop] = useState(0.65)
  const [intrusaoPincelTabletop, setIntrusaoPincelTabletop] = useState(0.22)
  useEffect(() => {
    if (tabletop.objetoSelecionado?.vitima) {
      setSecaoTabletop('vitima')
      setInspetorRecolhido(false)
      setAbaInspetorCAD('operacao')
      setGrupoRibbonAtivo(modoLayout === 'mobile' ? 'vitima' : null)
    }
  }, [tabletop.idSelecionado, modoLayout])

  const atendimentoTabletop = useAtendimentoTabletop(tabletop.cena, {
    aoVincularFicha: tabletop.vincularFicha,
    serialSessao: tabletop.serialSessao,
  })
  const operacoesSessao = useOperacoesSessao(tabletop, atendimentoTabletop)
  const persistenciaSessao = usePersistenciaSessao(tabletop, atendimentoTabletop)
  const iniciarEquipamentoTabletop = (tipo: 'calco' | 'bloco' | 'cunha' | 'fitaCatraca' | 'vstrut') => {
    if (tabletop.modo === 'atender') {
      const veiculo = tabletop.objetoSelecionado?.veiculo
        ? tabletop.objetoSelecionado
        : tabletop.cena.objetos.find(objeto => objeto.veiculo)
      if (veiculo) operacoesSessao.iniciarPosicionamentoEquipamento(veiculo.id, tipo)
      return
    }
    tabletop.iniciarPosicionamento(tipo)
  }

  const cenariosAutorais = useCenariosAutorais()
  const cenariosAutoraisResolvidos = useMemo(
    () => cenariosAutorais.lista.map((item) => item.cenario),
    [cenariosAutorais.lista],
  )
  const sessaoExtracao = useSessaoExtracao(cenariosAutoraisResolvidos)
  const [areaExtracao, setAreaExtracao] = useState<'retirada' | 'oficina'>('retirada')
  const estadoOficinaVitimas = useEstadoOficinaVitimas()
  const mostrarOficinaVitimas = aba === 'extracao' && areaExtracao === 'oficina'

  const [estados, setEstados] = useState<MapaEstados>({})
  const [selecionada, setSelecionada] = useState<string | null>(null)
  const [ultimoHit, setUltimoHit] = useState<HitVeiculo | null>(null)
  const [depuracaoHit, setDepuracaoHit] = useState<boolean>(false)

  const [idPerfilVeiculo, setIdPerfilVeiculo] = useState<PerfilVeiculo['id']>('hatchCompacto')
  const [idPerfilVitima, setIdPerfilVitima] = useState<string>('adultoMasculino')
  const [idAncora, setIdAncora] = useState('motorista')
  const [mostrarVitima, setMostrarVitima] = useState(true)
  const [etapaAnatomia, setEtapaAnatomia] = useState<EtapaAnatomia>('orientacao')
  const [etapasAnatomiaConcluidas, setEtapasAnatomiaConcluidas] = useState<EtapaAnatomia[]>([])
  const [tipoEstrutura, setTipoEstrutura] = useState<TipoEstruturaVeicular>('monobloco')
  const [explodido, setExplodido] = useState(false)
  // airbags inflados na Anatomia: 0 fechados, 1 totalmente inflados
  const [expansaoAirbagAnatomia, setExpansaoAirbagAnatomia] = useState(0)
  const animacaoAirbagAnatomia = useRef<number | null>(null)

  const [tipoColisao, setTipoColisao] = useState<TipoColisao>('frontal')
  const [alvoImpactoEscolhido, setAlvoImpacto] = useState<TipoAlvoImpacto>('outroVeiculo')
  // o alvo que vale para o tipo escolhido (abalroamento é sempre contra outro
  // veículo; lateral contra objeto, poste ou muro) — a escolha do aluno fica guardada
  const alvoImpacto = alvoEfetivo(tipoColisao, alvoImpactoEscolhido)
  // velocidade do evento: deixou de ser constante do tipo de colisão e virou
  // escolha do aluno. Trocar de tipo volta para a velocidade típica daquele tipo
  const [velocidadeImpacto, setVelocidadeImpacto] = useState<number>(
    () => colisao('frontal').velocidadeImpactoKmh,
  )
  const [posicaoEstabilizacao, setPosicaoEstabilizacao] = useState<PosicaoEstabilizacao>('quatroRodas')
  const [ferramentaEstabilizacao, setFerramentaEstabilizacao] = useState<FerramentaEstabilizacao>('calco')
  const equipamentoEstabilizacao: EquipamentoEstabilizacao = ferramentaEstabilizacao === 'selecao' ? 'calco' : ferramentaEstabilizacao
  const [colocacoesEstabilizacao, setColocacoesEstabilizacao] = useState<ColocacaoEquipamento[]>([])
  const [idColocacaoEstabilizacaoSelecionada, setIdColocacaoEstabilizacaoSelecionada] = useState<string | null>(null)
  const [cenariosEstabilizacaoConcluidos, setCenariosEstabilizacaoConcluidos] = useState<PosicaoEstabilizacao[]>([])
  const [mostrarInstabilidade, setMostrarInstabilidade] = useState(true)
  const [configuracao, setConfiguracao] = useState<ConfiguracaoVeiculo>('sobreRodas')
  const [decubito, setDecubito] = useState<Decubito>('dorsal')
  const [sentidoCabeca, setSentidoCabeca] = useState<SentidoCabeca>('frente')

  const [modoRota, setModoRota] = useState<ModoRota>('abertura')
  const [pontosRotaLivre, setPontosRotaLivre] = useState<Vetor3[]>([])
  const [direcaoSetaExtracao, setDirecaoSetaExtracao] = useState<Vetor3>({ x: 0, y: 0, z: -1 })
  const [ferramentaExtracao, setFerramentaExtracao] = useState<FerramentaExtracao>('nenhuma')
  const [obstaculosExternos, setObstaculosExternos] = useState<ObstaculoExterno[]>([])
  const [idAbertura, setIdAbertura] = useState('portaTraseiraEsquerda')
  const [anguloSelecionado, setAnguloSelecionado] = useState<AnguloNominal>(60)
  const [idComparada, setIdComparada] = useState<string | null>(null)
  const [comPrancha, setComPrancha] = useState(true)
  // girar em bloco é a manobra correta; desligar mostra o que sobra na cervical
  const [girarEmBloco, setGirarEmBloco] = useState(false)
  const [colarCervical, setColarCervical] = useState(false)
  const [comMeiaPrancha, setComMeiaPrancha] = useState(false)
  const [modoConceito, setModoConceito] = useState(false)
  /** "Ver o interior": carroceria translúcida na Extração — comando manual, ligado por padrão (comportamento de sempre). */
  const [verInteriorExtracao, setVerInteriorExtracao] = useState(true)
  const [estadoTeto, setEstadoTeto] = useState<EstadoTeto>('integro')
  const [sobreposicoes, setSobreposicoes] = useState({
    mostrarEixoColuna: true,
    mostrarTrajetoria: true,
    mostrarArco: true,
    mostrarPosicaoInicial: true,
    mostrarVetores: true,
    mostrarRastros: true,
    mostrarSetaCervical: true,
  })

  // Dinâmica de Suspensão Veicular e Vítima
  const [estadoSuspensao, setEstadoSuspensao] = useState<EstadoSuspensao>(ESTADO_SUSPENSAO_INICIAL)
  const perturbacaoAtiva = useRef<ForcaPerturbacao>({})

  const perturbarVeiculo = useCallback((forca: ForcaPerturbacao) => {
    perturbacaoAtiva.current = { ...forca }
  }, [])

  // "Perturbar Veículo" dispara uma sequência que passa pelas quatro
  // suspensões; enquanto ela corre, o botão diz o que está acontecendo.
  const [perturbando, setPerturbando] = useState(false)
  const temporizadoresPerturbacao = useRef<number[]>([])
  const perturbarQuatroCantos = useCallback(() => {
    temporizadoresPerturbacao.current.forEach((id) => window.clearTimeout(id))
    setPerturbando(true)
    temporizadoresPerturbacao.current = [
      ...SEQUENCIA_PERTURBACAO_QUATRO_CANTOS.map(({ atrasoMs, forca }) =>
        window.setTimeout(() => perturbarVeiculo(forca), atrasoMs),
      ),
      window.setTimeout(() => setPerturbando(false), DURACAO_PERTURBACAO_QUATRO_CANTOS_MS),
    ]
  }, [perturbarVeiculo])
  useEffect(() => () => temporizadoresPerturbacao.current.forEach((id) => window.clearTimeout(id)), [])

  // Oficina de Manejo de Vidros
  const [vidroSelecionado, setVidroSelecionado] = useState<IdVidro>('parabrisa')
  const [estadosVidros, setEstadosVidros] = useState<Record<IdVidro, EstadoManejoVidro>>({
    parabrisa: 'intacto',
    portaDianteiraEsquerda: 'intacto',
    portaDianteiraDireita: 'intacto',
    portaTraseiraEsquerda: 'intacto',
    portaTraseiraDireita: 'intacto',
    vigiaTraseiro: 'intacto',
  })
  const [protecoesVidros, setProtecoesVidros] = useState<ProtecoesManejo>(PROTECOES_INICIAIS)
  const [ferramentaVidro, setFerramentaVidro] = useState<FerramentaVidro>('glasMaster')
  const [ultimoResultadoVidro, setUltimoResultadoVidro] = useState<ResultadoAcaoVidro | null>(null)
  const [temInsulfilm, setTemInsulfilm] = useState(false)
  const [detritosNaVitima, setDetritosNaVitima] = useState(false)
  const [detritosNasProtecoes, setDetritosNasProtecoes] = useState(false)
  const [peliculaNoSolo, setPeliculaNoSolo] = useState(false)
  const [animacaoVidroAtiva, setAnimacaoVidroAtiva] = useState<{
    tipo: 'poLaminado' | 'estilhacosTemperado'
    origem: [number, number, number]
  } | null>(null)

  // Oficina de corte: prepara cenário e ferramental. As técnicas entram em
  // sequência própria quando forem definidas pelo instrutor.
  const [configuracaoCorte, setConfiguracaoCorte] = useState<ConfiguracaoOficinaCorte>('quatroRodas')
  const historicoOficinaRef = useRef<ControleHistorico | null>(null)

  // P3.1 — ocupantes da cinemática: pessoas (com/sem cinto), animais e objetos soltos
  const [ocupantes, setOcupantes] = useState<Ocupante[]>(() => [...OCUPANTES_PADRAO])
  // física real na carga solta: ligada por padrão, com o caminho procedural como
  // reserva caso o motor não carregue
  const [fisicaReal, setFisicaReal] = useState(true)
  const [fisicaCarga, setFisicaCarga] = useState<FisicaCarga>({ resultado: null, estado: 'desligada' })
  const [tonusOcupante, setTonusOcupante] = useState<TonusOcupante>('alerta')
  const [idFocoCinematica, setIdFocoCinematica] = useState(ID_OCUPANTE_PADRAO)
  const [idFocoExtracao, setIdFocoExtracao] = useState(ID_OCUPANTE_PADRAO)
  // Fases 1 a 5 da Cinemática
  const [trajetoriaFrontal, setTrajetoriaFrontal] = useState<TrajetoriaFrontal>('upAndOver')
  const [smallOverlap, setSmallOverlap] = useState(false)
  // colisão entre veículos: classe/velocidade/arranjo do outro e o mapa didático
  const [outroVeiculo, setOutroVeiculo] = useState<ConfiguracaoOutroVeiculo>(CONFIGURACAO_OUTRO_VEICULO_PADRAO)
  const alterarOutroVeiculo = useCallback(
    (parcial: Partial<ConfiguracaoOutroVeiculo>) => setOutroVeiculo((atual) => ({ ...atual, ...parcial })),
    [],
  )
  const [mostrarMapaDeformacao, setMostrarMapaDeformacao] = useState(false)
  // lataria sólida na Cinemática: carroceria opaca para ler os amassamentos, e a
  // estrutura deformada em raio-X para o dano estrutural não sumir atrás dela
  const [lataSolidaCinematica, setLataSolidaCinematica] = useState(false)
  const [ladoLateral, setLadoLateral] = useState<LadoImpactoLateral>('nearSide')
  const [pistaSelecionadaId, setPistaSelecionadaId] = useState<string | null>(null)
  const [pistasInspecionadas, setPistasInspecionadas] = useState<string[]>([])
  const [mostrarPistas, setMostrarPistas] = useState(true)
  const [modoInvestigadorAtivo, setModoInvestigadorAtivo] = useState(false)
  // Pilar 5.2: blindagem sem zona de deformação — eleva ΔV e pico de G
  const [veiculoBlindado, setVeiculoBlindado] = useState(false)
  // P3.3 — procedimentos internos, escopados à posição analisada na extração
  const [procedimentosFeitos, setProcedimentosFeitos] = useState<IdProcedimento[]>([])
  /**
   * Fase 4 — última alternância de procedimento, para comparar o efeito de UMA
   * ação (não o acumulado). `null` quando não há ação recente para mostrar:
   * início da sessão, troca de vítima/veículo ou depois de um desfazer/refazer
   * que muda `procedimentosFeitos` por fora deste fluxo.
   */
  const [ultimoProcedimentoAlterado, setUltimoProcedimentoAlterado] = useState<IdProcedimento | null>(null)
  const [mostrarPosicaoAnteriorBanco, setMostrarPosicaoAnteriorBanco] = useState(false)
  // P3.2 — seta cervical interativa
  const [orientacaoSeta, setOrientacaoSeta] = useState<OrientacaoSeta>(SETA_NEUTRA)

  const timeline = useTimeline()
  const perfilBase = perfilVeiculoPorId(idPerfilVeiculo)

  /**
   * O estado do teto é uma transformação do perfil mais um conjunto de peças
   * cortadas. Como cena, obstáculos e painel derivam de `perfil` e `estados`,
   * compor os dois aqui faz todo o resto acompanhar.
   */
  const perfil = useMemo(() => perfilComTeto(perfilBase, estadoTeto), [perfilBase, estadoTeto])

  const pararAnimacaoAirbag = useCallback(() => {
    if (animacaoAirbagAnatomia.current !== null) cancelAnimationFrame(animacaoAirbagAnatomia.current)
    animacaoAirbagAnatomia.current = null
  }, [])
  const mudarExpansaoAirbagAnatomia = useCallback((expansao: number) => {
    pararAnimacaoAirbag()
    setExpansaoAirbagAnatomia(expansao)
  }, [pararAnimacaoAirbag])
  // a deflagração real leva uns 30 ms; aqui é lenta de propósito, para dar para ver
  const deflagrarAirbagsAnatomia = useCallback(() => {
    pararAnimacaoAirbag()
    const inicio = performance.now()
    const passo = (agora: number) => {
      const t = Math.min(1, (agora - inicio) / DURACAO_DEFLAGRACAO_ANATOMIA_MS)
      setExpansaoAirbagAnatomia(1 - (1 - t) ** 3)
      animacaoAirbagAnatomia.current = t < 1 ? requestAnimationFrame(passo) : null
    }
    animacaoAirbagAnatomia.current = requestAnimationFrame(passo)
  }, [pararAnimacaoAirbag])
  // sair da aba ou trocar de veículo recolhe tudo: a próxima visita começa fechada
  useEffect(() => {
    pararAnimacaoAirbag()
    setExpansaoAirbagAnatomia(0)
  }, [aba, idPerfilVeiculo, pararAnimacaoAirbag])

  const oficina = useSessaoOficinaCorte({
    abaAtiva: aba === 'corte',
    perfil,
    configuracaoCorte,
    setConfiguracaoCorte,
    estadosVidros,
    setEstadosVidros,
    protecoesVidros,
    detritosNaVitima,
    detritosNasProtecoes,
    setDetritosNaVitima,
    setDetritosNasProtecoes,
    aoRomperVidroComDetritos: (origem) => {
      setAnimacaoVidroAtiva({
        tipo: 'estilhacosTemperado',
        origem,
      })
    },
    aoRegistrarHistorico: () => {
      historicoOficinaRef.current?.registrar()
    },
    aoEnquadrarOficina: () => {
      camera.executar('enquadrarOficina')
    },
  })

  const {
    modoOficinaCorte,
    setModoOficinaCorte,
    pecaOficinaCorte,
    setPecaOficinaCorte,
    ferramentaCorte,
    setFerramentaCorte,
    modoAlargador,
    setModoAlargador,
    mensagemInteracaoCorte,
    setMensagemInteracaoCorte,
    vidroCorte,
    setVidroCorte,
    idPortaCorte,
    estadoPortaCorte,
    estadosPortasCorte,
    atualizarEstadoPortaCorte,
    zonaOperacaoCorte,
    setZonaOperacaoCorte,
    operacaoPortaCorte,
    setOperacaoPortaCorte,
    resultadoOperacaoCorte,
    resultadoIntervencaoCorte,
    progressoFerramentaCorte,
    setProgressoFerramentaCorte,
    progressoEstruturalPortas,
    progressoEstruturalPortaAtual,
    atualizarProgressoEstruturalPorta,
    ajusteFerramentaCorte,
    setAjusteFerramentaCorte,
    posicaoFerramentaCorte,
    contatoFerramentaCorte,
    progressoSaidaPortaCorte,
    estadoExtensorCorte,
    setEstadoExtensorCorte,
    progressoEstruturalExtensor,
    condicaoEstabilizacaoExtensor,
    fluxoExtensorPronto,
    estadoTampaCorte,
    setEstadoTampaCorte,
    progressoEstruturalTampa,
    operacaoTampaCorte,
    setOperacaoTampaCorte,
    resultadoOperacaoTampaCorte,
    zonaOperacaoTampaCorte,
    setZonaOperacaoTampaCorte,
    ajusteFerramentaTampaCorte,
    setAjusteFerramentaTampaCorte,
    posicaoFerramentaTampaCorte,
    contatoFerramentaTampaCorte,
    ladoTerceiraPortaCorte,
    setLadoTerceiraPortaCorte,
    idTerceiraPortaCorte,
    estadoTerceiraPortaCorte,
    estadosTerceirasPortasCorte,
    setEstadoTerceiraPortaCorte,
    progressoEstruturalTerceirasPortas,
    operacaoTerceiraPortaCorte,
    setOperacaoTerceiraPortaCorte,
    resultadoOperacaoTerceiraPortaCorte,
    zonaOperacaoTerceiraPortaCorte,
    setZonaOperacaoTerceiraPortaCorte,
    ajusteFerramentaTerceiraPortaCorte,
    setAjusteFerramentaTerceiraPortaCorte,
    posicaoFerramentaTerceiraPortaCorte,
    contatoFerramentaTerceiraPortaCorte,
    segurandoFerramentaCorte,
    setSegurandoFerramentaCorte,
    progressoEstruturalAtual,
    playerCorte,
    ajusteFerramentaPlayerCorte,
    escolherFerramentaCorte,
    escolherModoAlargador,
    equiparFerramentaPorAtalho,
    motivoDaFerramentaDeCorte,
    executarAcaoPorta,
    executarAcaoManualPorta,
    gerenciarVidroCorte,
    executarAcaoTampa,
    executarAcaoManualTampa,
    executarAcaoTerceiraPorta,
    executarAcaoManualTerceiraPorta,
    pausarAcionamentoFerramenta,
    resetarEstadosOficinaCorte,
    acoesDePreparoDaPeca,
    gruposDaCaixaDeFerramentasCorte,
    interacaoPorta,
    interacaoTampa,
    interacaoTerceiraPorta,
  } = oficina

  const avaliacaoEstabilizacao = useMemo(
    () => avaliarColocacoes(posicaoEstabilizacao, perfil, colocacoesEstabilizacao),
    [posicaoEstabilizacao, perfil, colocacoesEstabilizacao],
  )
  const estadosEfetivos = useMemo(
    // as ações do aluno vêm por último: ele pode agir sobre o que a técnica e os
    // procedimentos internos já deixaram
    () => ({ ...estadosDaTecnica(estadoTeto), ...estadosDosProcedimentos(procedimentosFeitos, idAncora, perfil), ...estados }),
    [estadoTeto, procedimentosFeitos, idAncora, estados, perfil],
  )

  /* --- Desfazer por módulo -------------------------------------------------
     O `Historico<T>` do domínio já era genérico, mas só o Table top o usava:
     remover um calço, quebrar um vidro ou marcar um procedimento eram
     irreversíveis a não ser pelo botão de restaurar tudo, que joga fora o
     exercício inteiro.

     Cada instantâneo guarda SÓ o que a ação daquele módulo altera. Incluir mais
     faria desfazer reverter coisas que ninguém pediu — a câmera, o módulo
     aberto, o vidro em foco. */

  const historicoEstrutura = useHistoricoDeModulo(
    () => ({ estados, selecionada }),
    (i) => { setEstados(i.estados); setSelecionada(i.selecionada) },
  )

  const historicoEstabilizacao = useHistoricoDeModulo(
    () => ({ colocacoes: colocacoesEstabilizacao, selecionado: idColocacaoEstabilizacaoSelecionada }),
    (i) => {
      setColocacoesEstabilizacao(i.colocacoes)
      setIdColocacaoEstabilizacaoSelecionada(i.selecionado)
    },
  )

  const historicoVidros = useHistoricoDeModulo(
    () => ({
      estados: estadosVidros,
      protecoes: protecoesVidros,
      insulfilm: temInsulfilm,
      naVitima: detritosNaVitima,
      nasProtecoes: detritosNasProtecoes,
      noSolo: peliculaNoSolo,
      resultado: ultimoResultadoVidro,
    }),
    (i) => {
      setEstadosVidros(i.estados)
      setProtecoesVidros(i.protecoes)
      setTemInsulfilm(i.insulfilm)
      setDetritosNaVitima(i.naVitima)
      setDetritosNasProtecoes(i.nasProtecoes)
      setPeliculaNoSolo(i.noSolo)
      setUltimoResultadoVidro(i.resultado)
      setAnimacaoVidroAtiva(null)
    },
  )

  const historicoOficina = useHistoricoDeModulo<InstantaneoHistoricoOficina>(
    () => oficina.obterInstantaneoHistorico(),
    (i) => oficina.restaurarInstantaneoHistorico(i),
  )
  historicoOficinaRef.current = historicoOficina

  const historicoExtracao = useHistoricoDeModulo(
    () => ({
      pontos: pontosRotaLivre,
      direcaoSeta: direcaoSetaExtracao,
      obstaculos: obstaculosExternos,
      procedimentos: procedimentosFeitos,
      seta: orientacaoSeta,
    }),
    (i) => {
      setPontosRotaLivre(i.pontos ?? [])
      if (i.direcaoSeta) setDirecaoSetaExtracao(i.direcaoSeta)
      setObstaculosExternos(i.obstaculos)
      setProcedimentosFeitos(i.procedimentos)
      setOrientacaoSeta(i.seta)
      // desfazer/refazer pode restaurar `procedimentos` para um estado que não
      // corresponde mais a "a última coisa que o aluno alternou" — mostrar o
      // efeito de uma ação que o desfazer acabou de apagar seria mentir
      setUltimoProcedimentoAlterado(null)
    },
  )

  /* Cinemática fica de fora de propósito: lá não se EDITA nada — os controles
     são parâmetros do evento, e mudá-los de volta já é o desfazer natural. */
  const historicoDoModulo = aba === 'tabletop'
    ? {
        desfazer: tabletop.desfazer,
        refazer: tabletop.refazer,
        podeDesfazer: tabletop.podeDesfazer,
        podeRefazer: tabletop.podeRefazer,
      }
    : aba === 'maquete'
      ? historicoEstrutura
      : aba === 'estabilizacao'
        ? historicoEstabilizacao
        : aba === 'corte'
          ? historicoOficina
          : aba === 'extracao'
            ? historicoExtracao
            : undefined

  useEffect(() => {
    window.localStorage.setItem('csv-lab-tema', tema)
  }, [tema])

  // trocar a âncora em foco (outra vítima, outro cenário) invalida a última
  // ação registrada: ela era sobre o banco de outra posição
  useEffect(() => {
    setUltimoProcedimentoAlterado(null)
  }, [idAncora])

  /* Desfazer e refazer por teclado, em QUALQUER módulo que tenha histórico.
     O atalho vivia dentro do efeito exclusivo do Table top, de modo que a
     trilha de ferramentas oferecia o comando nos outros módulos mas o Ctrl+Z
     não respondia. Ignorado com o foco num campo, para não atrapalhar quem
     está digitando um número no painel. */
  useEffect(() => {
    if (!historicoDoModulo) return

    const aoTeclar = (evento: KeyboardEvent) => {
      const alvo = evento.target as HTMLElement | null
      if (alvo?.tagName === 'INPUT' || alvo?.tagName === 'TEXTAREA' || alvo?.isContentEditable) return
      if (!(evento.ctrlKey || evento.metaKey) || evento.key.toLowerCase() !== 'z') return

      evento.preventDefault()
      if (evento.shiftKey) historicoDoModulo.refazer()
      else historicoDoModulo.desfazer()
    }

    window.addEventListener('keydown', aoTeclar)
    return () => window.removeEventListener('keydown', aoTeclar)
  }, [historicoDoModulo])

  // Atalhos de manipulação do Table top: ignorados com o foco num campo de
  // texto, para não atrapalhar quem está digitando um nome no painel.
  useEffect(() => {
    if (aba !== 'tabletop') return

    const aoTeclar = (evento: KeyboardEvent) => {
      const alvo = evento.target as HTMLElement | null
      const digitando = alvo?.tagName === 'INPUT' || alvo?.tagName === 'TEXTAREA' || alvo?.isContentEditable
      if (digitando) return

      const ctrlOuCmd = evento.ctrlKey || evento.metaKey
      if (ctrlOuCmd && evento.key.toLowerCase() === 'd') {
        if (tabletop.idSelecionado) {
          evento.preventDefault()
          tabletop.duplicar(tabletop.idSelecionado)
        }
      } else if (evento.key === 'Delete' || evento.key === 'Backspace') {
        if (tabletop.idSelecionado) {
          evento.preventDefault()
          tabletop.remover(tabletop.idSelecionado)
        }
      } else if (evento.key === 'Escape') {
        if (tabletop.idOlhandoPara) { tabletop.cancelarOlharPara(); return }
        if (tabletop.tipoParaPosicionar) {
          tabletop.cancelarPosicionamento()
        } else {
          tabletop.selecionar(null)
        }
      } else if (evento.key === 'w' || evento.key === 'W') {
        tabletop.escolherFerramenta('translate')
      } else if (evento.key === 'e' || evento.key === 'E') {
        tabletop.escolherFerramenta('rotate')
      } else if (evento.key === 'r' || evento.key === 'R') {
        tabletop.escolherFerramenta('scale')
      }
    }

    window.addEventListener('keydown', aoTeclar)
    return () => window.removeEventListener('keydown', aoTeclar)
  }, [
    aba,
    tabletop.idSelecionado,
    tabletop.duplicar,
    tabletop.remover,
    tabletop.selecionar,
    tabletop.escolherFerramenta,
    tabletop.cancelarOlharPara,
    tabletop.idOlhandoPara,
    tabletop.tipoParaPosicionar,
  ])


  /**
   * Atalhos da barra de ferramentas de estabilização (estilo Photoshop):
   * 'V' para Seleção/Ponteiro, '1' a '5' para Calço, Bloco, Cunha, Fita e V-Strut.
   */
  useEffect(() => {
    if (aba !== 'estabilizacao') return

    const aoTeclar = (evento: KeyboardEvent) => {
      const alvo = evento.target as HTMLElement | null
      if (alvo?.tagName === 'INPUT' || alvo?.tagName === 'TEXTAREA' || alvo?.isContentEditable) return
      if (evento.ctrlKey || evento.metaKey || evento.altKey) return

      if (evento.key.toLowerCase() === 'v') {
        evento.preventDefault()
        setFerramentaEstabilizacao('selecao')
      } else if (evento.key === '1') {
        evento.preventDefault()
        setFerramentaEstabilizacao('calco')
      } else if (evento.key === '2') {
        evento.preventDefault()
        setFerramentaEstabilizacao('bloco')
      } else if (evento.key === '3') {
        evento.preventDefault()
        setFerramentaEstabilizacao('cunha')
      } else if (evento.key === '4') {
        evento.preventDefault()
        setFerramentaEstabilizacao('fitaCatraca')
      } else if (evento.key === '5') {
        evento.preventDefault()
        setFerramentaEstabilizacao('vstrut')
      }
    }

    window.addEventListener('keydown', aoTeclar)
    return () => window.removeEventListener('keydown', aoTeclar)
  }, [aba])

  useEffect(() => {
    const aoTeclarGlobal = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'b') {
        e.preventDefault()
        setInspetorRecolhido((v) => !v)
      }
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'h') {
        e.preventDefault()
        setDepuracaoHit((v) => !v)
      }
    }
    window.addEventListener('keydown', aoTeclarGlobal)
    return () => window.removeEventListener('keydown', aoTeclarGlobal)
  }, [])

  useEffect(() => {
    carregarCenarioMvp()
      .then((c) => {
        setCenario(c)
        if (c.tipoVeiculo in PERFIS_VEICULO) setIdPerfilVeiculo(c.tipoVeiculo as PerfilVeiculo['id'])
      })
      .catch((e: unknown) => {
        setErro(e instanceof Error ? e.message : 'Erro desconhecido ao carregar o cenário.')
      })
  }, [])

  // remover o ocupante em foco (ou trocar de veículo) não pode deixar o foco
  // apontando para alguém que não existe mais
  useEffect(() => {
    if (!ocupantePorId(ocupantes, idFocoCinematica)) {
      setIdFocoCinematica(ocupantes[0]?.id ?? ID_OCUPANTE_PADRAO)
    }
  }, [ocupantes, idFocoCinematica])

  useEffect(() => {
    const vitimas = vitimasPorPrioridade(ocupantes)
    const foco = ocupantePorId(ocupantes, idFocoExtracao)
    if (!foco || foco.tipo !== 'pessoa') setIdFocoExtracao(vitimas[0]?.id ?? ID_OCUPANTE_PADRAO)
  }, [ocupantes, idFocoExtracao])

  useEffect(() => {
    if (!avaliacaoEstabilizacao.secundariaConcluida) return
    setCenariosEstabilizacaoConcluidos((lista) =>
      lista.includes(posicaoEstabilizacao) ? lista : [...lista, posicaoEstabilizacao],
    )
  }, [avaliacaoEstabilizacao.secundariaConcluida, posicaoEstabilizacao])

  // Loop de simulação da dinâmica de suspensão
  useEffect(() => {
    let animId: number
    let ultimoTempo = performance.now()

    const step = (tempoAtual: number) => {
      const dt = Math.min((tempoAtual - ultimoTempo) / 1000, 0.05)
      ultimoTempo = tempoAtual

      setEstadoSuspensao((prev) => {
        const prox = atualizarSuspensao(
          prev,
          dt,
          avaliacaoEstabilizacao.suspensaoAnulada,
          avaliacaoEstabilizacao.rolamentoTravado,
          perturbacaoAtiva.current,
          undefined,
          avaliacaoEstabilizacao.rigidezProgressiva,
        )
        // Amortecer o impulso de perturbação
        perturbacaoAtiva.current = {
          forcaY: (perturbacaoAtiva.current.forcaY ?? 0) * 0.82,
          torqueRoll: (perturbacaoAtiva.current.torqueRoll ?? 0) * 0.82,
          torquePitch: (perturbacaoAtiva.current.torquePitch ?? 0) * 0.82,
          forcaZ: (perturbacaoAtiva.current.forcaZ ?? 0) * 0.82,
        }
        return prox
      })

      animId = requestAnimationFrame(step)
    }

    animId = requestAnimationFrame(step)
    return () => cancelAnimationFrame(animId)
  }, [
    avaliacaoEstabilizacao.suspensaoAnulada,
    avaliacaoEstabilizacao.rolamentoTravado,
    avaliacaoEstabilizacao.rigidezProgressiva,
  ])

  const executarManejoVidroAtual = useCallback(() => {
    historicoVidros.registrar()
    const res = executarManejoVidro(vidroSelecionado, ferramentaVidro, protecoesVidros, temInsulfilm)
    setUltimoResultadoVidro(res)
    if (res.sucesso) {
      setEstadosVidros((prev) => ({ ...prev, [vidroSelecionado]: res.novoEstado }))
      setDetritosNaVitima((atual) => atual || res.detritosNaVitima)
      setDetritosNasProtecoes((atual) => atual || res.detritosNasProtecoes)
      if (res.nuvemDePo) {
        setAnimacaoVidroAtiva({
          tipo: 'poLaminado',
          origem: [0, (perfil.cinturaY + perfil.tetoY) * 0.52, perfil.colunaA.zBase],
        })
      } else if (res.estilhacosProjetados) {
        setAnimacaoVidroAtiva({
          tipo: 'estilhacosTemperado',
          origem: [-perfil.largura / 2, (perfil.cinturaY + perfil.tetoY) / 2, perfil.colunaB.z],
        })
      }
    }
  }, [vidroSelecionado, ferramentaVidro, protecoesVidros, temInsulfilm, perfil])

  const removerPeliculaVidro = useCallback((sentido: 'dentroParaFora' | 'foraParaDentro') => {
    historicoVidros.registrar()
    const res = removerPeliculaCraquelada(vidroSelecionado, sentido, protecoesVidros)
    setUltimoResultadoVidro(res)
    setEstadosVidros((prev) => ({ ...prev, [vidroSelecionado]: res.novoEstado }))
    setDetritosNaVitima((atual) => atual || res.detritosNaVitima)
    setDetritosNasProtecoes((atual) => atual || res.detritosNasProtecoes)
    setPeliculaNoSolo(sentido === 'dentroParaFora')
  }, [vidroSelecionado, protecoesVidros])

  const restaurarVidros = useCallback(() => {
    historicoVidros.registrar()
    setEstadosVidros({
      parabrisa: 'intacto',
      portaDianteiraEsquerda: 'intacto',
      portaDianteiraDireita: 'intacto',
      portaTraseiraEsquerda: 'intacto',
      portaTraseiraDireita: 'intacto',
      vigiaTraseiro: 'intacto',
    })
    setUltimoResultadoVidro(null)
    setAnimacaoVidroAtiva(null)
    setTemInsulfilm(false)
    setDetritosNaVitima(false)
    setDetritosNasProtecoes(false)
    setPeliculaNoSolo(false)
  }, [])

  const adicionarOcupante = useCallback((ocupante: Ocupante) => {
    setOcupantes((lista) => adicionarOcupanteNaLista(lista, ocupante))
  }, [])

  const removerOcupante = useCallback((id: string) => {
    setOcupantes((lista) => {
      const alvo = ocupantePorId(lista, id)
      // nunca remove a última pessoa: sem ninguém, a cena de cinemática não tem o que mostrar
      if (alvo?.tipo === 'pessoa' && pessoas(lista).length <= 1) return lista
      return removerOcupanteDaLista(lista, id)
    })
  }, [])

  const alterarRetencaoOcupante = useCallback((id: string, retencao: ModoRetencao) => {
    setOcupantes((lista) => comRetencao(lista, id, retencao))
  }, [])

  /* Focar uma vítima na extração mexe em cinco estados. Existia só dentro do
     painel; com o corpo clicável na cena, os dois caminhos precisam levar ao
     mesmo lugar. */
  const focarVitimaExtracao = useCallback((id: string) => {
    const vitima = ocupantePorId(ocupantes, id)
    if (!vitima) return
    setIdFocoExtracao(id)
    setIdAncora(vitima.idAncora)
    setIdPerfilVitima(vitima.idPerfil)
    setPontosRotaLivre([])
    timeline.reiniciar()
  }, [ocupantes, timeline])

  const carregarFocoDoCenario = useCallback((cenarioId: string, vitimaId?: string, reiniciarPreparacao = true) => {
    const cenarioPedagogico = cenarioExtracaoPorId(cenarioId, cenariosAutoraisResolvidos)
    const vitima = cenarioPedagogico.vitimas.find((item) => item.id === vitimaId) ?? cenarioPedagogico.vitimas[0]!
    const veiculo = cenarioPedagogico.veiculos.find((item) => item.id === vitima.veiculoId) ?? cenarioPedagogico.veiculos[0]!
    setOcupantes(ocupantesDoCenario(cenarioPedagogico, veiculo.id))
    setIdFocoExtracao(vitima.id)
    setIdAncora(vitima.idAncora)
    setIdPerfilVitima(vitima.idPerfil)
    setConfiguracao(veiculo.configuracao)
    if (veiculo.configuracao !== 'sobreRodas') setIdAbertura('tampaTraseira')
    setDecubito(veiculo.decubito ?? 'dorsal')
    setSentidoCabeca(veiculo.sentidoCabeca ?? 'frente')
    setPontosRotaLivre([])
    if (reiniciarPreparacao) setProcedimentosFeitos([])
    timeline.reiniciar()
  }, [timeline, cenariosAutoraisResolvidos])

  const escolherCenarioExtracao = useCallback((id: string) => {
    sessaoExtracao.escolherCenario(id)
    carregarFocoDoCenario(id)
  }, [carregarFocoDoCenario, sessaoExtracao.escolherCenario])

  const focarVitimaCenario = useCallback((id: string) => {
    sessaoExtracao.focarVitima(id)
    carregarFocoDoCenario(sessaoExtracao.sessao.cenario.id, id, false)
  }, [carregarFocoDoCenario, sessaoExtracao.focarVitima, sessaoExtracao.sessao.cenario.id])

  const alterarEstadoClinico = useCallback((id: string, estado: EstadoClinico) => {
    setOcupantes((lista) => comEstadoClinico(lista, id, estado))
  }, [])

  const posicionarObstaculoExterno = useCallback((tipo: TipoObstaculoExterno, x: number, z: number) => {
    historicoExtracao.registrar()
    setObstaculosExternos((lista) => [...lista, { id: `${tipo}-${Date.now()}-${lista.length}`, tipo, x, z }])
  }, [])

  const adicionarPontoRota = useCallback((ponto: Vetor3) => {
    // um traçado livre é UM passo: coalesce enquanto o dedo não solta
    historicoExtracao.registrar('rota-livre')
    setPontosRotaLivre((lista) => {
      const anterior = lista.at(-1)
      return anterior && Math.hypot(ponto.x - anterior.x, ponto.z - anterior.z) < 0.08 ? lista : [...lista, ponto]
    })
  }, [])

  const alterarDirecaoSetaExtracao = useCallback((direcao: Vetor3) => {
    historicoExtracao.registrar('direcao-seta')
    setDirecaoSetaExtracao(direcao)
  }, [historicoExtracao])

  const alternarProcedimento = useCallback((id: IdProcedimento) => {
    historicoExtracao.registrar()
    const retirando = procedimentosFeitos.includes(id)
    const proxima = retirando ? procedimentosFeitos.filter((p) => p !== id) : [...procedimentosFeitos, id]
    setProcedimentosFeitos(proxima)
    setUltimoProcedimentoAlterado(id)
    if (id === 'colocarColarCervical') {
      setColarCervical(!retirando)
    }
    if (sessaoExtracao.sessao.modo === 'cenario') {
      sessaoExtracao.preparar(
        { procedimentosInternos: proxima.length === 0 ? 'pendente' : proxima.length === IDS_PROCEDIMENTO.length ? 'concluido' : 'parcial' },
        `${PROCEDIMENTOS[id].nome}: ${retirando ? 'desfeito para comparar o cenário' : 'executado'}.`,
      )
    }
  }, [procedimentosFeitos, sessaoExtracao.preparar, sessaoExtracao.sessao.modo])

  const aoAlternarColarCervical = useCallback((colar: boolean) => {
    setColarCervical(colar)
    setProcedimentosFeitos((lista) => {
      if (colar && !lista.includes('colocarColarCervical')) {
        return [...lista, 'colocarColarCervical']
      }
      if (!colar && lista.includes('colocarColarCervical')) {
        return lista.filter((p) => p !== 'colocarColarCervical')
      }
      return lista
    })
  }, [])

  const posicionarEquipamentoEstabilizacao = useCallback((
    equipamento: EquipamentoEstabilizacao,
    posicao: PontoSolo,
    atributos?: Partial<ColocacaoEquipamento>,
  ) => {
    historicoEstabilizacao.registrar()
    const id = `${equipamento}-${crypto.randomUUID()}`
    setColocacoesEstabilizacao((lista) => [...lista, { id, equipamento, posicao, ...atributos }])
    if (equipamento === 'vstrut' || equipamento === 'fitaCatraca') setIdColocacaoEstabilizacaoSelecionada(id)
  }, [])

  const removerEquipamentoEstabilizacao = useCallback((id: string) => {
    historicoEstabilizacao.registrar()
    setColocacoesEstabilizacao((lista) => lista.filter((colocacao) => colocacao.id !== id))
    setIdColocacaoEstabilizacaoSelecionada((selecionado) => selecionado === id ? null : selecionado)
  }, [])

  const atualizarColocacaoEstabilizacao = useCallback((id: string, atualizacao: Partial<ColocacaoEquipamento>) => {
    // arrastar o slider de rotação é um passo só, não um por pixel
    historicoEstabilizacao.registrar(atualizacao.ligacao && !atualizacao.posicao ? undefined : `apoio:${id}`)
    setColocacoesEstabilizacao((lista) =>
      lista.map((c) => (c.id === id ? { ...c, ...atualizacao } : c)),
    )
  }, [])

  const montagemEstabilizacao = useMontagemEstabilizacao({
    ativo: aba === 'estabilizacao', posicao: posicaoEstabilizacao, perfil,
    ferramenta: ferramentaEstabilizacao, colocacoes: colocacoesEstabilizacao,
    selecionado: idColocacaoEstabilizacaoSelecionada, aoSelecionar: setIdColocacaoEstabilizacaoSelecionada,
    aoPosicionar: posicionarEquipamentoEstabilizacao, aoAtualizar: atualizarColocacaoEstabilizacao,
  })
  useEffect(() => { setIdColocacaoEstabilizacaoSelecionada(null) }, [ferramentaEstabilizacao])
  useEffect(() => {
    setColocacoesEstabilizacao(cs => cs.map(c => c.ligacao ? { ...c, ligacao: { ...c.ligacao, tensionada: false } } : c))
  }, [idPerfilVeiculo])
  useEffect(() => {
    if (montagemEstabilizacao.visivel) {
      setGrupoRibbonAtivo(modoLayout === 'mobile' ? 'montagem' : null)
      setInspetorRecolhido(false)
      setAbaInspetorCAD('operacao')
    } else if (aba === 'estabilizacao') {
      setGrupoRibbonAtivo(grupo => grupo === 'montagem' ? null : grupo)
      setAbaInspetorCAD('propriedades')
    }
  }, [aba, ferramentaEstabilizacao, idColocacaoEstabilizacaoSelecionada, modoLayout])

  const aplicarModo = useCallback((novo: ModoVisualizacao) => {
    setModo(novo)
    setCamadas(PRESETS[novo].camadas)
    setOpacidadeCarroceria(PRESETS[novo].opacidadeCarroceria)
    setMostrarRotulos(PRESETS[novo].mostrarRotulos)
    // "Ver o interior" começa ligado a cada entrada no módulo — mesma
    // translucidez de sempre; o professor desliga quando quiser o veículo
    // íntegro como referência.
    setVerInteriorExtracao(true)
  }, [])

  const trocarAba = useCallback(
    /**
     * `origemCinematica` só é passado por quem pula PARA a cinemática a
     * partir de outro módulo (`aplicarCinematicaDaVitima`) — um clique comum
     * na aba (inclusive um clique direto em "Cinemática" no menu) não passa
     * nada, e por isso limpa a origem: só existe "Voltar" depois de um pulo.
     */
    (nova: Aba, origemCinematica?: Aba) => {
      setAba(nova)
      setMostrarQuatroImpactos(false)
      setModuloCinematicaOrigem(nova === 'cinematica' ? (origemCinematica ?? null) : null)
      setGrupoRibbonAtivo(null)
      setIdColocacaoEstabilizacaoSelecionada(null)
      timeline.reiniciar()
      aplicarModo(moduloPorId(nova).modo)
      // A oficina reaproveita o preset "Estrutura" (gaiola e zonas em evidência),
      // mas ali a carroceria quase invisível (0.14) esconde a própria peça que o
      // aluno precisa localizar e cortar. Os rótulos de pilar/zona de energia
      // também competem com os marcadores de operação da porta.
      if (nova === 'corte') {
        setOpacidadeCarroceria(0.65)
        setMostrarRotulos(false)
      }
    },
    [aplicarModo, timeline],
  )

  /** Clique na cena: pega o conjunto primeiro e aprofunda no clique seguinte. */
  const selecionarDaCena = useCallback((id: string | null) => {
    if (id === null) setUltimoHit(null)
    setSelecionada((atual) => (id === null ? null : resolverSelecao(id, atual)))
    if (aba === 'extracao' && id) {
      if (id.startsWith('portaDianteiraEsquerda')) {
        setIdAbertura('portaDianteiraEsquerda')
      } else if (id.startsWith('portaDianteiraDireita')) {
        setIdAbertura('portaDianteiraDireita')
      } else if (id.startsWith('portaTraseiraEsquerda')) {
        setIdAbertura('portaTraseiraEsquerda')
      } else if (id.startsWith('portaTraseiraDireita')) {
        setIdAbertura('portaTraseiraDireita')
      } else if (id.startsWith('tampaTraseira')) {
        setIdAbertura('tampaTraseira')
      }
    }
  }, [aba])

  const executarAcao = useCallback((id: string, acao: AcaoPeca) => {
    historicoEstrutura.registrar()
    setEstados((mapa) => comAcao(mapa, id, acao))
  }, [])

  const prepararEtapaAnatomia = useCallback((id: EtapaAnatomia) => {
    const etapa = etapaAnatomiaPorId(id)
    setEtapaAnatomia(id)
    aplicarModo(etapa.modo)
    setSelecionada(etapa.pecaInicial)
    setExplodido(false)
    setEstados(estadosDaEtapaAnatomia(id))
    setUltimoHit(null)
    if (id === 'porta') camera.executar('enquadrarSelecao', 'portaDianteiraEsquerda')
    else if (id === 'estrutura') camera.executar('vistaLateral')
    else camera.executar('vistaIsometrica')
  }, [aplicarModo, camera])

  const inspecionarPecaAnatomia = useCallback((id: string) => {
    const preparacao = prepararPecaAnatomia(etapaAnatomia, id)
    aplicarModo(preparacao.modo)
    setEstados(preparacao.estados)
    setSelecionada(id)
    setUltimoHit(null)
    camera.executar('enquadrarSelecao', id)
  }, [aplicarModo, camera, etapaAnatomia])

  useEffect(() => {
    if (aba === 'maquete' && selecionada && !pecaPresenteNoPerfil(selecionada, perfil)) {
      setSelecionada(etapaAnatomiaPorId(etapaAnatomia).pecaInicial)
      setUltimoHit(null)
    }
  }, [aba, selecionada, perfil, etapaAnatomia])

  const restaurarCena = useCallback(() => {
    setEstados(restaurarTudo())
    setSelecionada(null)
    setUltimoHit(null)
    setOcupantes([...OCUPANTES_PADRAO])
    setIdFocoCinematica(ID_OCUPANTE_PADRAO)
    setIdFocoExtracao(ID_OCUPANTE_PADRAO)
    setProcedimentosFeitos([])
    setOrientacaoSeta(SETA_NEUTRA)
    setColocacoesEstabilizacao([])
    setPontosRotaLivre([])
    setObstaculosExternos([])
    setFerramentaExtracao('nenhuma')
    aplicarModo(modo)
  }, [aplicarModo, modo])

  const quadro = amostrarCinematica(tipoColisao, timeline.tempo, velocidadeImpacto)

  /**
   * Rota, ângulo e obstáculos são calculados aqui e descem prontos para a cena
   * e para o painel. Assim o número do painel e o arco da cena são o mesmo
   * cálculo, e não duas leituras que podem divergir.
   */
  const extracao = useMemo(() => {
    const vitimasOrdenadas = vitimasPorPrioridade(ocupantes)
    const vitimaFoco = vitimasOrdenadas.find((v) => v.id === idFocoExtracao) ?? vitimasOrdenadas[0]!
    const ancora = ancoraPorId(perfil, vitimaFoco.idAncora)
    const proporcoes = perfilVitimaPorId(vitimaFoco.idPerfil)
    const deitada = vitimaDeitada(configuracao)
    // a colocação é a única coisa que a configuração muda: o eixo da coluna sai
    // dela, e tudo o mais (ângulo, rota, obstáculos) continua derivando do eixo
    const colocacaoInicial = colocacaoNaConfiguracao(
      perfil,
      ancora,
      proporcoes,
      configuracao,
      decubito,
      sentidoCabeca,
    )
    const eixoColuna = eixoColunaDaVitima(
      colocacaoInicial,
      proporcoes,
      deitada ? POSE_ALINHADA : POSE_SENTADA,
    )
    const aberturas = aberturasDeSaida(perfil)

    const construir = (chave: string): ReturnType<typeof construirRota> =>
      modoRota === 'abertura'
        ? construirRotaPorAbertura(eixoColuna, aberturaPorId(perfil, chave))
        : construirRota(
            eixoColuna,
            Number(chave) as AnguloNominal,
            ladoNominalDaAncora(ancora.lado, Number(chave) as AnguloNominal),
          )

    const rotaBase = construirRotaPorAbertura(eixoColuna, aberturaPorId(perfil, idAbertura))
    const rota = modoRota === 'livre'
      ? (() => {
          try {
            return construirRotaDirecional(eixoColuna, direcaoSetaExtracao)
          } catch {
            return rotaBase
          }
        })()
      : modoRota === 'abertura'
        ? rotaBase
        : construir(String(anguloSelecionado))
    const rotaComparada = modoRota === 'livre' || idComparada == null ? null : construir(idComparada)
    // os obstáculos dependem do estado das peças: reclinar um encosto ou tirar
    // o apoio de cabeça precisa mudar a folga na hora
    const obstaculos = obstaculosDaRota(perfil, eixoColuna, rota, proporcoes, estadosEfetivos)
    const estadosAntesDosProcedimentos = { ...estadosDaTecnica(estadoTeto), ...estados }
    const obstaculosAntesDosProcedimentos = obstaculosDaRota(
      perfil,
      eixoColuna,
      rota,
      proporcoes,
      estadosAntesDosProcedimentos,
    )
    const folgaAntesDosProcedimentos = folgaMinima(
      perfil,
      eixoColuna,
      rota,
      proporcoes,
      estadosAntesDosProcedimentos,
    )
    const folgaDepoisDosProcedimentos = folgaMinima(
      perfil,
      eixoColuna,
      rota,
      proporcoes,
      estadosEfetivos,
    )

    /**
     * Fase 4 — efeito de UMA ação (não o acumulado de "antes" que já existe
     * acima). `estadosAntesAcao` é o mapa efetivo com só o último procedimento
     * alternado desfeito de volta; `estadosEfetivos` já é o "depois" atual.
     * A silhueta do banco só existe para os três procedimentos que de fato
     * mexem numa peça (`PROCEDIMENTOS_DO_BANCO`) — os outros (freio de mão,
     * vidros, airbag, cobrir a vítima) não têm peça para desenhar de volta.
     */
    const efeitoUltimaAcao = ultimoProcedimentoAlterado
      ? (() => {
          const feitosAntes = feitosAntesDaUltimaAlternancia(procedimentosFeitos, ultimoProcedimentoAlterado)
          const estadosAntesAcao = {
            ...estadosDaTecnica(estadoTeto),
            ...estadosDosProcedimentos(feitosAntes, idAncora, perfil),
            ...estados,
          }
          const idsBanco = idsDoBanco(ancora)
          return {
            idProcedimento: ultimoProcedimentoAlterado,
            nome: PROCEDIMENTOS[ultimoProcedimentoAlterado].nome,
            ligado: procedimentosFeitos.includes(ultimoProcedimentoAlterado),
            efeito: efeitoGeometricoDaAcao(perfil, eixoColuna, rota, proporcoes, estadosAntesAcao, estadosEfetivos),
            silhuetaBanco: PROCEDIMENTOS_DO_BANCO.includes(ultimoProcedimentoAlterado)
              ? {
                  reclinado: estadoDe(estadosAntesAcao, idsBanco.encosto) === 'aberta',
                  recuado: estadoDe(estadosAntesAcao, idsBanco.assento) === 'afastada',
                  apoioCabecaVisivel: estadoDe(estadosAntesAcao, idsBanco.apoioCabeca) !== 'removida',
                }
              : null,
          }
        })()
      : null

    // com o veículo invertido o que decide é o vão vertical sob os bancos, não a
    // folga lateral: deitada, a vítima passa por baixo deles
    const folgaVertical = configuracao === 'invertido'
      ? folgaVerticalNoTeto(perfil, eixoColuna, rota, proporcoes, estadosEfetivos)
      : null

    // o que a rota custa à vítima: arco varrido pelos ombros e torção que sobra
    const opcoesGiro = { deitada, fracaoTorcao: girarEmBloco ? 0 : undefined }
    const custo = custoDoGiro(rota, eixoColuna, colocacaoInicial, proporcoes, opcoesGiro)

    // as quatro rotas nominais lado a lado: giro E folga juntos, porque ângulo
    // menor não é rota mais livre (ACHADOS §21) e mostrar só o giro ensinaria isso
    const comparativo = ANGULOS_NOMINAIS.map((anguloNominal) => {
      const nominal = construirRota(
        eixoColuna,
        anguloNominal,
        ladoNominalDaAncora(ancora.lado, anguloNominal),
      )
      return {
        anguloNominal,
        leitura: leituraDaRota(nominal),
        custo: custoDoGiro(nominal, eixoColuna, colocacaoInicial, proporcoes, opcoesGiro),
        folga: folgaMinima(perfil, eixoColuna, nominal, proporcoes, estadosEfetivos),
      }
    })

    const pontosDaRota = rota.pontosLivres ?? [eixoColuna.baseColuna, rota.pontoSaida]
    // Uma vítima só conta como "grave conhecida" depois de avaliada o suficiente
    // (ou em demonstração, que é livre de exigência clínica): impede que o
    // rótulo 3D, o inspetor e o aviso de prioridade vazem a severidade antes do
    // XABCDE. Achado da auditoria da Fase 0 — docs/fase-0-auditoria.md, seção 4.
    const graveConhecida = (vitima: Ocupante) =>
      vitima.estadoClinico === 'grave' && vitimaSeveridadeVisivel(sessaoExtracao.sessao, vitima.id)
    const vitimasSecundarias = vitimasOrdenadas
      .filter((vitima) => vitima.id !== vitimaFoco.id)
      .map((vitima) => {
        const ancoraVitima = ancoraPorId(perfil, vitima.idAncora)
        const proporcoesVitima = perfilVitimaPorId(vitima.idPerfil)
        const colocacao = colocacaoNaConfiguracao(perfil, ancoraVitima, proporcoesVitima, configuracao, decubito, sentidoCabeca)
        return {
          id: vitima.id,
          nome: vitima.nome,
          estadoClinico: vitima.estadoClinico ?? 'estavel' as const,
          estadoClinicoVisivel: vitimaSeveridadeVisivel(sessaoExtracao.sessao, vitima.id),
          proporcoes: proporcoesVitima,
          colocacao,
          interfere: vitimaInterfereNaTrajetoria(
            colocacao.posicaoPelve,
            proporcoesVitima.larguraOmbros,
            pontosDaRota,
          ),
        }
      })
    const obstaculosExternosInterferindo = obstaculosQueInterferem(obstaculosExternos, pontosDaRota)
    const prioridadePendente = (vitimaFoco.estadoClinico ?? 'estavel') !== 'grave'
      && vitimasOrdenadas.some((vitima) => vitima.id !== vitimaFoco.id && graveConhecida(vitima))

    return {
      vitimaFoco,
      ancora,
      proporcoes,
      colocacaoInicial,
      eixoColuna,
      aberturas,
      rota,
      rotaComparada,
      obstaculos,
      obstaculosAntesDosProcedimentos,
      folgaAntesDosProcedimentos,
      folgaDepoisDosProcedimentos,
      efeitoUltimaAcao,
      folgaVertical,
      custo,
      comparativo,
      vitimasSecundarias,
      obstaculosExternosInterferindo,
      prioridadePendente,
    }
  }, [perfil, ocupantes, idFocoExtracao, configuracao, decubito, sentidoCabeca, modoRota, idAbertura, anguloSelecionado, idComparada, direcaoSetaExtracao, pontosRotaLivre, obstaculosExternos, estadosEfetivos, girarEmBloco, estadoTeto, estados, sessaoExtracao.sessao, ultimoProcedimentoAlterado, procedimentosFeitos, idAncora])

  const idsObstruindo = useMemo(
    () => (aba === 'extracao' ? extracao.obstaculos.filter((o) => o.interfere).map((o) => o.idPeca) : []),
    [aba, extracao.obstaculos],
  )

  const amostraExtracao = useMemo(() => {
    const deitada = vitimaDeitada(configuracao)
    const paDeForno = configuracao !== 'sobreRodas'
    return amostrarRota(extracao.rota, extracao.eixoColuna, timeline.tempo, {
      deitada,
      comPrancha: comPrancha || paDeForno,
      ...(paDeForno ? {
        paDeForno: {
          direcaoElevacao: direcaoElevacaoPaDeForno(configuracao),
          altura: 0.24,
        },
      } : {}),
      ...(girarEmBloco ? { fracaoTorcao: 0 } : {}),
    })
  }, [comPrancha, configuracao, extracao.eixoColuna, extracao.rota, girarEmBloco, timeline.tempo])

  const faseAnimacaoExtracao = amostraExtracao.fase

  const marcosAnimacaoExtracao = marcosDaRetirada(
    configuracao !== 'sobreRodas',
    comPrancha,
  )

  /** dispositivos que o tipo de colisão aciona E o perfil declara */
  const srsDoEvento = useMemo(() => {
    const definicao = colisao(tipoColisao)
    const todos = [...definicao.srsAcionados, ...(definicao.impactoSecundario?.srsAcionados ?? [])]
    return todos.filter((chave) => perfil.srs[chave])
  }, [tipoColisao, perfil])



  const registrosDecisaoExtracao = useMemo<RegistroSimulacao[]>(() => {
    const total = Math.max(1, sessaoExtracao.sessao.decisoes.length)
    return sessaoExtracao.sessao.decisoes.map((decisao, indice) => ({
      id: decisao.id,
      tempo: (indice + 1) / total,
      titulo: decisao.titulo,
      descricao: decisao.justificativa
        ? `${decisao.descricao} · Justificativa: ${decisao.justificativa}`
        : decisao.descricao,
      categoria: 'decisao',
    }))
  }, [sessaoExtracao.sessao.decisoes])

  const irParaDecisaoExtracao = useCallback((tempo: number) => {
    const total = sessaoExtracao.sessao.decisoes.length
    if (total === 0) return
    const indice = Math.max(0, Math.min(total - 1, Math.round(tempo * total) - 1))
    const decisao = sessaoExtracao.sessao.decisoes[indice]
    if (decisao) sessaoExtracao.navegar(decisao.etapa)
  }, [sessaoExtracao.navegar, sessaoExtracao.sessao.decisoes])

  const ocupanteFocoCinematica = ocupantePorId(ocupantes, idFocoCinematica)

  /** movimento do ocupante em foco no instante atual — a mesma conta que a cena usa */
  const reacaoFocoCinematica = useMemo(() => {
    if (!ocupanteFocoCinematica || ocupanteFocoCinematica.tipo !== 'pessoa') return null
    const ancoraFoco = ancoraPorId(perfil, ocupanteFocoCinematica.idAncora)
    const proporcoesFoco = perfilVitimaPorId(ocupanteFocoCinematica.idPerfil)
    const superficies = superficiesDoHabitaculo(perfil, ancoraFoco)
    const origem = origemDeContatoPadrao(ancoraFoco, proporcoesFoco)
    return reacaoDoOcupante(tipoColisao, timeline.tempo, ocupanteFocoCinematica.retencao, superficies, origem)
  }, [ocupanteFocoCinematica, perfil, tipoColisao, timeline.tempo])

  /** âncoras cujo ocupante está sem cinto agora — o cinto desenhado some para elas */
  const semCintoAncoras = useMemo(
    () => pessoas(ocupantes).filter((o) => o.retencao === 'semCinto').map((o) => o.idAncora),
    [ocupantes],
  )

  const conceitoAtivo = aba === 'extracao' && modoConceito

  const saidaPelaTraseira = extracao.rota.abertura?.id === 'tampaTraseira' || extracao.rota.anguloNominal === 0

  const estadosMaquete = useMemo(() => {
    const mapa = { ...estadosEfetivos }
    // saída pela traseira: no sedan o vidro (fixo) e a prateleira saem e os bancos
    // de trás são rebatidos durante a abertura dos acessos; no hatch o vidro sobe
    // com a tampa e só os bancos se movem
    if (aba === 'extracao' && configuracao === 'sobreRodas' && saidaPelaTraseira) {
      Object.assign(mapa, estadosDoAcessoTraseiro(perfil, acessoTraseiroNoTempo(timeline.tempo)))
    }
    if (aba === 'extracao' && comPrancha && configuracao === 'sobreRodas') {
      const sufixo = sufixoAncora(idAncora)
      if (timeline.tempo >= 0.18 || procedimentosFeitos.includes('retirarApoioCabeca')) {
        mapa[`banco${sufixo}.apoioCabeca`] = 'removida'
      }
      if (timeline.tempo >= 0.28 || procedimentosFeitos.includes('reclinarEncosto')) {
        mapa[`banco${sufixo}.encosto`] = 'aberta'
      }
    }
    return mapa
  }, [estadosEfetivos, aba, comPrancha, configuracao, idAncora, timeline.tempo, procedimentosFeitos, perfil, saidaPelaTraseira])

  const contexto = useMemo(
    () => ({
      perfil,
      modo,
      camadas: conceitoAtivo
        ? PRESET_CONCEITO.camadas
        // lataria sólida: a estrutura volta a ser desenhada — atrás da chapa
        // opaca ela não aparece, mas é dela que sai o raio-X do dano estrutural
        : aba === 'cinematica' && lataSolidaCinematica
          ? { ...camadas, estrutura: true }
          : camadas,
      opacidadeCarroceria: conceitoAtivo
        ? PRESET_CONCEITO.opacidadeCarroceria
        // "Ver o interior" desligado mostra o veículo íntegro, como referência —
        // só se aplica na Extração; nos demais módulos nada muda.
        : (aba === 'extracao' && !verInteriorExtracao) || (aba === 'cinematica' && lataSolidaCinematica)
          ? 1
          : opacidadeCarroceria,
      estados: estadosMaquete,
      selecionada,
      selecionar: selecionarDaCena,
      mostrarRotulos: conceitoAtivo ? PRESET_CONCEITO.mostrarRotulos : mostrarRotulos,
      expansaoAirbag: modo === 'cinematica'
        ? quadro.expansaoAirbag
        : aba === 'maquete' ? expansaoAirbagAnatomia : 0,
      // só os dispositivos que ESTE tipo de colisão aciona, e só os que o perfil
      // declara: apresentar todos disparando em qualquer evento é o que §21 veda.
      // Na Anatomia não há evento: o controle mostra todos os do perfil, para
      // ver o espaço que ocupam, e o painel diz que não é uma colisão.
      srsAcionados: modo === 'cinematica'
        ? srsDoEvento
        : aba === 'maquete' ? srsAtivos(perfil) : [],
      retencaoEmEvidencia: modo === 'cinematica' ? quadro.cintoAtivo : false,
      idsEmAlerta: idsObstruindo,
      colunasSeccionadas: tecnicaDeTeto(estadoTeto).colunasSeccionadas,
      semCintoAncoras,
      // o modo conceito reduz a cena ao essencial; pintar por aço ali seria
      // devolver detalhe justamente onde ele foi retirado de propósito
      pinturaPorAco: conceitoAtivo ? false : pinturaPorAco,
      explodido: aba === 'maquete' ? explodido : false,
      animacaoBancoExtracao:
        aba === 'extracao'
          ? {
              idAncora,
              abaixarTodosBancos: configuracao !== 'sobreRodas' || anguloSelecionado === 0 || idAbertura === 'tampaTraseira',
              fracaoApoioCabeca: procedimentosFeitos.includes('retirarApoioCabeca')
                ? 1
                : (amostraExtracao.fracaoApoioCabeca ?? 0),
              fracaoAbaixarBanco: procedimentosFeitos.includes('reclinarEncosto')
                ? 1
                : (amostraExtracao.fracaoAbaixarBanco ?? 0),
              fracaoRebaterBancosTraseiros: procedimentosFeitos.includes('rebaterBancosTraseiros')
                ? 1
                : (amostraExtracao.fracaoRebaterBancosTraseiros ?? 0),
            }
          : null,
      ultimoHit,
      depuracaoHit,
      aoRegistrarHit: setUltimoHit,
    }),
    [perfil, modo, camadas, opacidadeCarroceria, estadosMaquete, selecionada, selecionarDaCena, mostrarRotulos, conceitoAtivo, estadoTeto, quadro.expansaoAirbag, expansaoAirbagAnatomia, quadro.cintoAtivo, idsObstruindo, srsDoEvento, semCintoAncoras, pinturaPorAco, explodido, aba, verInteriorExtracao, lataSolidaCinematica, comPrancha, configuracao, idAncora, procedimentosFeitos, amostraExtracao, anguloSelecionado, idAbertura, ultimoHit, depuracaoHit],
  )

  /* O que está selecionado, por módulo. A trilha usa para saber se há o que
     enquadrar; a barra de estado, para dizer o quê; o inspetor, o que mostrar.
     Fica antes de qualquer retorno porque o efeito abaixo depende dele. */
  const idSelecionado = aba === 'tabletop'
    ? tabletop.idSelecionado
    : aba === 'estabilizacao'
      ? idColocacaoEstabilizacaoSelecionada
      : aba === 'maquete'
        ? selecionada
        : aba === 'cinematica'
          ? idFocoCinematica
          : aba === 'extracao'
            ? idFocoExtracao
            : null

  useEffect(() => {
    setInspetorRecolhido(false)
  }, [idSelecionado, aba])

  // mesma resolução que a cena usa: o painel lê o dano que a cena desenha
  const deformacaoEvento = useMemo(
    () =>
      deformacaoDoEvento({
        tipo: tipoColisao,
        alvo: alvoImpacto,
        perfil,
        velocidadeKmh: velocidadeImpacto,
        smallOverlap,
        outroVeiculo,
      }),
    [tipoColisao, alvoImpacto, perfil, velocidadeImpacto, smallOverlap, outroVeiculo],
  )

  if (erro) {
    return (
      <main className="estado">
        <h1>RESCUE-LAB</h1>
        <p>{erro}</p>
      </main>
    )
  }
  if (!cenario) {
    return <TelaCarregamento />
  }

  const quantidadeSrs = srsAtivos(perfil).length

  const aplicarPresetMulticorpo = (preset: 'projetil' | 'cranio' | 'ejecaoParcial') => {
    if (preset === 'projetil') {
      setTipoColisao('frontal')
      setVelocidadeImpacto(50)
      setOcupantes([
        { id: '1', nome: 'Motorista (Com Cinto)', tipo: 'pessoa', idPerfil: 'padrao', idAncora: 'motorista', retencao: 'comCinto' },
        { id: '2', nome: 'Passageiro Traseiro (Projétil)', tipo: 'pessoa', idPerfil: 'padrao', idAncora: 'traseiroEsquerdo', retencao: 'semCinto' },
      ])
      setIdFocoCinematica('1')
      timeline.reiniciar()
    } else if (preset === 'cranio') {
      setTipoColisao('lateral')
      setVelocidadeImpacto(45)
      setOcupantes([
        { id: '1', nome: 'Motorista', tipo: 'pessoa', idPerfil: 'padrao', idAncora: 'motorista', retencao: 'comCinto' },
        { id: '2', nome: 'Passageiro Dianteiro', tipo: 'pessoa', idPerfil: 'padrao', idAncora: 'passageiro', retencao: 'comCinto' },
      ])
      setIdFocoCinematica('1')
      timeline.reiniciar()
    } else if (preset === 'ejecaoParcial') {
      setTipoColisao('capotamento')
      setVelocidadeImpacto(60)
      setTonusOcupante('inconsciente')
      timeline.reiniciar()
    }
  }

  /**
   * "Ver cinemática desta vítima", pedido pela Oficina: leva a aba
   * Cinemática para o mecanismo da ficha (colisão, alvo, assento, cinto). A
   * cena 3D não existe dentro da Oficina — só este estado muda de aba.
   */
  const aplicarCinematicaDaVitima = (cinematica: CinematicaFichaVitima) => {
    setTipoColisao(cinematica.tipoColisao)
    setAlvoImpacto(cinematica.alvoImpacto)
    setVelocidadeImpacto(cinematica.velocidadeImpacto ?? colisao(cinematica.tipoColisao).velocidadeImpactoKmh)
    setOcupantes([
      { id: '1', nome: 'Vítima', tipo: 'pessoa', idPerfil: 'padrao', idAncora: cinematica.idAncora, retencao: cinematica.retencao },
    ])
    setIdFocoCinematica('1')
    // trocarAba (não setAba) também acerta o modo de visualização 3D do
    // módulo — sem isso, a cena troca de aba mas fica com o modo herdado
    // da Extração (ex.: ângulos de retirada) até o professor clicar de
    // novo na aba Cinemática. Passar `aba` como origem é o que liga o
    // botão "Voltar" da Cinemática de volta para cá.
    trocarAba('cinematica', aba)
  }

  const voltarDaCinematica = moduloCinematicaOrigem
    ? () => trocarAba(moduloCinematicaOrigem)
    : undefined

  const exportarParaOficina = () => {
    const exp = exportarColisaoParaOficina(tipoColisao, velocidadeImpacto)
    setEstados((ant: MapaEstados) => ({ ...ant, ...exp.estadosPecas }))
    trocarAba('corte')
  }

  const iniciarReplayLento = () => {
    timeline.reiniciar()
    timeline.alternarReproducao()
  }

  const alternarModoInvestigador = () => {
    const novoModo = !modoInvestigadorAtivo
    setModoInvestigadorAtivo(novoModo)
    if (novoModo) {
      timeline.irPara(1.0)
    }
  }

  const pistasCenaCinematica = obterPistasAtivas(
    tipoColisao,
    velocidadeImpacto,
    ocupanteFocoCinematica?.retencao === 'comCinto',
    trajetoriaFrontal,
  )

  const renderPainelCinematica = (secoes: readonly SecaoPainelCinematica[]) => (
    <PainelCinematica
      secoes={secoes}
      tipoColisao={tipoColisao}
      alvoImpacto={alvoImpacto}
      velocidadeImpacto={velocidadeImpacto}
      quadro={quadro}
      ocupantes={ocupantes}
      ocupanteFoco={ocupanteFocoCinematica}
      reacaoFoco={reacaoFocoCinematica}
      srsAcionados={srsDoEvento}
      aoEscolherTipo={(tipo) => {
        setTipoColisao(tipo)
        setVelocidadeImpacto(colisao(tipo).velocidadeImpactoKmh)
        timeline.reiniciar()
      }}
      aoEscolherVelocidade={(kmh) => {
        setVelocidadeImpacto(kmh)
        timeline.reiniciar()
      }}
      aoEscolherAlvo={(tipo) => {
        setAlvoImpacto(tipo)
        timeline.reiniciar()
      }}
      mostrarVetores={sobreposicoes.mostrarVetores}
      mostrarRastros={sobreposicoes.mostrarRastros}
      mostrarEixoColuna={sobreposicoes.mostrarEixoColuna}
      aoAlternar={(chave, valor) => setSobreposicoes((estado) => ({ ...estado, [chave]: valor }))}
      fisicaReal={fisicaReal}
      estadoFisica={fisicaCarga.estado}
      tonusOcupante={tonusOcupante}
      estresseBiomecanico={fisicaCarga.resultado?.estresseBiomecanico}
      impactos={fisicaCarga.resultado?.impactos ?? []}
      aprisionamentos={fisicaCarga.resultado?.aprisionamentos ?? []}
      ejecoes={fisicaCarga.resultado?.ejecoes ?? []}
      aoAlternarFisica={setFisicaReal}
      aoEscolherTonus={setTonusOcupante}
      ehEV={perfil.energia.propulsao === 'eletrico' || perfil.energia.propulsao === 'hibrido'}
      ehBlindado={veiculoBlindado}
      aoAlternarBlindado={setVeiculoBlindado}
      trajetoriaFrontal={trajetoriaFrontal}
      aoAlterarTrajetoriaFrontal={setTrajetoriaFrontal}
      smallOverlap={smallOverlap}
      aoAlternarSmallOverlap={setSmallOverlap}
      outroVeiculo={outroVeiculo}
      aoAlterarOutroVeiculo={alterarOutroVeiculo}
      leituraEntreVeiculos={deformacaoEvento.colisaoPrincipal?.leitura ?? null}
      danoVeicular={deformacaoEvento.danoPrincipal}
      mostrarMapaDeformacao={mostrarMapaDeformacao}
      aoAlternarMapaDeformacao={setMostrarMapaDeformacao}
      lataSolida={lataSolidaCinematica}
      aoAlternarLataSolida={setLataSolidaCinematica}
      ladoLateral={ladoLateral}
      aoAlterarLadoLateral={setLadoLateral}
      pistas={pistasCenaCinematica}
      pistaSelecionada={pistaPorId(pistaSelecionadaId ?? '') ?? null}
      aoSelecionarPista={(id) => {
        setPistaSelecionadaId(id)
        if (id && !pistasInspecionadas.includes(id)) {
          setPistasInspecionadas((ant) => [...ant, id])
        }
      }}
      pistasInspecionadas={pistasInspecionadas}
      mostrarPistas={mostrarPistas}
      aoAlternarMostrarPistas={setMostrarPistas}
      aoAplicarPresetMulticorpo={aplicarPresetMulticorpo}
      aoVerReplay={iniciarReplayLento}
      aoExportarParaOficina={exportarParaOficina}
    />
  )

  const renderPainelEstabilizacao = (secoes: readonly SecaoPainelEstabilizacao[]) => (
    <PainelEstabilizacao
      secoes={secoes}
      perfil={perfil}
      posicao={posicaoEstabilizacao}
      equipamentoSelecionado={equipamentoEstabilizacao}
      colocacoes={colocacoesEstabilizacao}
      avaliacao={avaliacaoEstabilizacao}
      concluidos={cenariosEstabilizacaoConcluidos}
      mostrarInstabilidade={mostrarInstabilidade}
      estadoSuspensao={estadoSuspensao}
      colarCervical={colarCervical}
      aoEscolherPosicao={(posicao) => {
        setPosicaoEstabilizacao(posicao)
        setColocacoesEstabilizacao([])
        setIdColocacaoEstabilizacaoSelecionada(null)
      }}
      aoEscolherEquipamento={setFerramentaEstabilizacao}
      aoAlternarInstabilidade={setMostrarInstabilidade}
      aoAlternarColarCervical={aoAlternarColarCervical}
      aoPerturbar={perturbarVeiculo}
      aoReiniciar={() => {
        setColocacoesEstabilizacao([])
        setIdColocacaoEstabilizacaoSelecionada(null)
      }}
    />
  )

  const renderPainelVidros = (secoes: readonly SecaoPainelManejoVidros[]) => (
    <PainelManejoVidros
      secoes={secoes}
      vidroSelecionado={vidroSelecionado}
      estadosVidros={estadosVidros}
      protecoes={protecoesVidros}
      ferramentaSelecionada={ferramentaVidro}
      ultimoResultado={ultimoResultadoVidro}
      temInsulfilm={temInsulfilm}
      detritosNaVitima={detritosNaVitima}
      aoAlternarInsulfilm={setTemInsulfilm}
      aoRemoverPelicula={removerPeliculaVidro}
      aoSelecionarVidro={setVidroSelecionado}
      aoAlterarProtecao={(chave, valor) =>
        setProtecoesVidros((estado) => ({ ...estado, [chave]: valor }))
      }
      aoSelecionarFerramenta={setFerramentaVidro}
      aoExecutarManejo={executarManejoVidroAtual}
      aoRestaurarVidros={restaurarVidros}
    />
  )


  /**
   * Caixa de ferramentas de estabilização estilo Photoshop, no topo da trilha lateral.
   * Permite equipar calço, bloco, cunha, fita e v-strut ou alternar para modo seleção.
   */
  const gruposExtrasEstabilizacao = [
    {
      id: 'ferramentas-estabilizacao',
      rotulo: 'Equipamentos de estabilização',
      ferramentas: [
        {
          id: 'selecao',
          rotulo: 'Ponteiro / Selecionar',
          atalho: 'V',
          Icone: IconeSelecao,
          aoAcionar: () => setFerramentaEstabilizacao('selecao'),
          ativa: ferramentaEstabilizacao === 'selecao',
        },
        {
          id: 'calco',
          rotulo: 'Calço escalonado',
          atalho: '1',
          Icone: IconeCalco,
          aoAcionar: () => setFerramentaEstabilizacao('calco'),
          ativa: ferramentaEstabilizacao === 'calco',
        },
        {
          id: 'bloco',
          rotulo: 'Bloco',
          atalho: '2',
          Icone: IconeBloco,
          aoAcionar: () => setFerramentaEstabilizacao('bloco'),
          ativa: ferramentaEstabilizacao === 'bloco',
        },
        {
          id: 'cunha',
          rotulo: 'Cunha de resgate',
          atalho: '3',
          Icone: IconeCunha,
          aoAcionar: () => setFerramentaEstabilizacao('cunha'),
          ativa: ferramentaEstabilizacao === 'cunha',
        },
        {
          id: 'fitaCatraca',
          rotulo: 'Fita catraca',
          atalho: '4',
          Icone: IconeFitaCatraca,
          aoAcionar: () => setFerramentaEstabilizacao('fitaCatraca'),
          ativa: ferramentaEstabilizacao === 'fitaCatraca',
        },
        {
          id: 'vstrut',
          rotulo: 'V-Strut',
          atalho: '5',
          Icone: IconeVStrut,
          aoAcionar: () => setFerramentaEstabilizacao('vstrut'),
          ativa: ferramentaEstabilizacao === 'vstrut',
        },
      ],
    },
  ]


  const renderPainelCorte = (secoes: readonly SecaoPainelOficinaCorte[]) => (
    <PainelOficinaCorte
      secoes={secoes}
      player={playerCorte}
      aoSelecionarTecnica={() => setGrupoRibbonAtivo(null)}
      configuracao={configuracaoCorte}
      pinturaPorAco={pinturaPorAco}
      aoEscolherConfiguracao={(novaConfiguracao) => {
        // tombado sobre o lado do motorista: as portas esquerdas estão contra o
        // solo, então o exercício passa para a porta equivalente do lado alto
        if (novaConfiguracao === 'tombado' && vidroCorte.endsWith('Esquerda')) {
          setVidroCorte(vidroCorte.replace(/Esquerda$/, 'Direita') as typeof vidroCorte)
        }
        setConfiguracaoCorte(novaConfiguracao)
      }}
      aoAlternarReforcos={setPinturaPorAco}
      aoReenquadrarCamera={() => {
        camera.executar('enquadrarOficina')
      }}
      modo={modoOficinaCorte}
      aoMudarModo={setModoOficinaCorte}
      ferramenta={ferramentaCorte}
      aoEscolherFerramenta={escolherFerramentaCorte}
      modoAlargador={modoAlargador}
      aoEscolherModoAlargador={escolherModoAlargador}
      estadoPorta={estadoPortaCorte}
      mensagemInteracao={mensagemInteracaoCorte}
      segurandoFerramenta={segurandoFerramentaCorte}
      progressoFerramenta={progressoFerramentaCorte}
      progressoEstrutural={progressoEstruturalAtual}
      aoManejarVidro={gerenciarVidroCorte}
      aoTestarManual={() => executarAcaoManualPorta('testarAberturaManual')}
      aoSustentarPorta={() => executarAcaoManualPorta('sustentarPorta')}
      aoRemoverPorta={() => executarAcaoManualPorta('removerPorta')}
      aoReiniciarPratica={resetarEstadosOficinaCorte}
    />
  )

  const renderPainelTabletop = (secoes: readonly SecaoPainelTabletop[]) => (
    <PainelTabletop
      secoes={secoes}
      montagemSimples={tabletop.modo === 'montar'}
      cena={tabletop.cena}
      selecionado={tabletop.objetoSelecionado}
      ferramenta={tabletop.ferramenta}
      fila={tabletop.fila}
      podeDesfazer={tabletop.podeDesfazer}
      podeRefazer={tabletop.podeRefazer}
      cenarioTravado={tabletop.cenarioTravado}
      aoAlternarTravaCenario={tabletop.alternarTravaCenario}
      aoSelecionar={tabletop.selecionar}
      aoEscolherFerramenta={tabletop.escolherFerramenta}
      aoAdicionar={tabletop.adicionar}
      aoIniciarPosicionamento={(tipo) => {
        tabletop.iniciarPosicionamento(tipo)
        // fecha a folha/dock pra equipe ver e tocar a cena 3D
        setGrupoRibbonAtivo(null)
      }}
      aoIniciarAtendimento={() => tabletop.definirModo('atender')}
      aoTransformar={tabletop.transformar}
      aoRenomearObjeto={tabletop.renomearObjeto}
      aoAlterarCor={tabletop.alterarCor}
      aoDuplicar={tabletop.duplicar}
      aoRemover={tabletop.remover}
      aoResetar={tabletop.resetarTransformacao}
      aoRenomearCena={tabletop.renomearCena}
      aoCriarCena={tabletop.criarCena}
      aoCarregarExemplo={(id) => {
        // cenário de aula: o roteiro (vítimas, achados) precisa acompanhar a cena carregada
        if (id && obterCenarioDidaticoPorId(id)) carregarCenarioDidatico(id)
        else tabletop.carregarExemplo(id)
        // em pé, o quadro padrão (feito para um veículo) corta a cena pelos lados
        if (modoLayout === 'mobile') camera.executar('enquadrarCena')
      }}
      aoImportar={tabletop.importar}
      aoDesfazer={tabletop.desfazer}
      aoRefazer={tabletop.refazer}
      aoVincularVitima={tabletop.vincularVitima}
      aoDesvincularVitima={tabletop.desvincularVitima}
      aoMoverNaFila={tabletop.moverNaFila}
      ancorasLivres={tabletop.ancorasLivres}
      aoAtualizarVitima={tabletop.atualizarVitima}
      aoVincularFicha={tabletop.vincularFicha}
      aoAtualizarRisco={tabletop.atualizarRisco}
      aoAtualizarVeiculo={tabletop.atualizarVeiculo}
      aoDefinirPosicaoFinal={tabletop.definirPosicaoFinal}
      aoExecutarManejoVidro={tabletop.executarManejoVidro}
      aoRestaurarVidros={tabletop.restaurarVidros}
      ultimoResultadoVidro={tabletop.ultimoResultadoVidro}
      aoAplicarDeformacao={tabletop.aplicarDeformacaoVeiculo}
      pincel={{
        ativo: pincelTabletopAtivo,
        larguraM: larguraPincelTabletop,
        intrusaoM: intrusaoPincelTabletop,
        aoAlternar: (ativo) => {
          if (ativo) {
            tabletop.cancelarPosicionamento()
            setGrupoRibbonAtivo(null)
          }
          setPincelTabletopAtivo(ativo)
        },
        aoDefinirLargura: setLarguraPincelTabletop,
        aoDefinirIntrusao: setIntrusaoPincelTabletop,
        aoRestaurar: tabletop.limparAmassados,
      }}
      aoExecutarCorte={tabletop.executarCorteVeiculo}
      aoSelecionarPecaVeiculo={tabletop.selecionarPecaVeiculo}
      aoRestaurarEstrutura={tabletop.restaurarEstruturaVeiculo}
      ultimoResultadoCorte={tabletop.ultimoResultadoCorte}
      aoAlternarBloqueio={tabletop.alternarBloqueio}
      aoAlternarOculto={tabletop.alternarOculto}
      atendimento={{
        modoExibicao: 'instrutor',
        triagensDeclaradas: atendimentoTabletop.triagensDeclaradas,
      }}
    />
  )

  const renderRoteiroAula = (secao: 'cenario' | 'vitima' | 'corte' | 'estabilizacao') => (
    <PainelMesaTabletop
      cenarioId={cenarioDidaticoId}
      secao={secao}
      cena={tabletop.cena}
      selecionado={tabletop.objetoSelecionado}
      aoSelecionar={tabletop.selecionar}
      aoAlterarHistoria={tabletop.alterarHistoria}
      aoVincularFicha={tabletop.vincularFicha}
      atendimento={atendimentoTabletop}
      aoCarregarCenario={carregarCenarioDidatico}
      editor={renderPainelTabletop(['editor'])}
      operacoes={(objeto, secaoOperacional) => (
        <OperacoesVeiculo
          key={`${secaoOperacional}-${objeto.id}`}
          objeto={objeto}
          cena={tabletop.cena}
          operacoes={atendimentoTabletop.sessao.operacoes}
          modoInstrutor
          abasDisponiveis={secaoOperacional === 'estabilizacao' ? ['estabilizar'] : ['cortes', 'vidros']}
          onPosicionarEquipamento={(tipo) => {
            tabletop.iniciarPosicionamento(tipo)
            setInspetorRecolhido(true)
            setGrupoRibbonAtivo(null)
          }}
          onTestarEstabilidade={objeto.veiculo?.posicaoFinal === 'sobreRodas'
            ? () => tabletop.testarBalanco(objeto.id) : undefined}
          onCortar={(idPeca, estado) => operacoesSessao.cortar(objeto.id, idPeca, estado)}
          onVidro={(idVidro, ferramenta) => operacoesSessao.manejarVidro(objeto.id, idVidro, ferramenta)}
          onProtecao={(chave) => operacoesSessao.alternarProtecao(objeto.id, chave)}
        />
      )}
    />
  )

  const painelCena = (
    <div className="grupo-controle">
      <span className="titulo-controle">Cena</span>
      <label className="campo">
        <span>veículo</span>
        <select
          value={idPerfilVeiculo}
          onChange={(evento) => setIdPerfilVeiculo(evento.target.value as PerfilVeiculo['id'])}
        >
          {Object.values(PERFIS_VEICULO).map((item) => (
            <option key={item.id} value={item.id}>{item.nome}</option>
          ))}
        </select>
      </label>
      {/* a Anatomia mostra o veículo vazio; a vítima só entra na Oficina de
          corte, onde a proteção dela (pose lágrima) é parte do exercício */}
      {aba === 'corte' && (
        <>
          <label className="campo">
            <span>vítima</span>
            <select value={idPerfilVitima} onChange={(evento) => setIdPerfilVitima(evento.target.value)}>
              {IDS_PERFIL_VITIMA.map((id) => (
                <option key={id} value={id}>{perfilVitimaPorId(id).nome}</option>
              ))}
            </select>
          </label>
          <label className="campo">
            <span>posição</span>
            <select value={idAncora} onChange={(evento) => setIdAncora(evento.target.value)}>
              {perfil.ancoras.map((ancora) => (
                <option key={ancora.id} value={ancora.id}>{ancora.nome}</option>
              ))}
            </select>
          </label>
          <label className="toggle">
            <input type="checkbox" checked={mostrarVitima} onChange={(evento) => setMostrarVitima(evento.target.checked)} />
            mostrar vítima
          </label>
        </>
      )}
      <button onClick={restaurarCena}>Restaurar cena</button>
    </div>
  )

  const renderPainelExtracao = (secoes: readonly SecaoPainelExtracao[]) => (
    <PainelExtracao
      secoes={secoes}
      modoRota={modoRota}
      aberturas={extracao.aberturas}
      idAbertura={idAbertura}
      anguloSelecionado={anguloSelecionado}
      idComparada={idComparada}
      rota={extracao.rota}
      obstaculos={extracao.obstaculos}
      folgaVertical={extracao.folgaVertical}
      custo={extracao.custo}
      comparativo={extracao.comparativo}
      girarEmBloco={girarEmBloco}
      aoAlternarBloco={setGirarEmBloco}
      configuracao={configuracao}
      decubito={decubito}
      sentidoCabeca={sentidoCabeca}
      comPrancha={comPrancha}
      comMeiaPrancha={comMeiaPrancha}
      colarCervical={colarCervical || procedimentosFeitos.includes('colocarColarCervical')}
      aoAlternarMeiaPrancha={setComMeiaPrancha}
      aoAlternarColarCervical={aoAlternarColarCervical}
      modoConceito={modoConceito}
      verInterior={verInteriorExtracao}
      estadoTeto={estadoTeto}
      ganhoDeEspaco={ganhoDeEspaco(perfilBase, estadoTeto, extracao.ancora, extracao.proporcoes)}
      mostrarEixoColuna={sobreposicoes.mostrarEixoColuna}
      mostrarTrajetoria={sobreposicoes.mostrarTrajetoria}
      mostrarArco={sobreposicoes.mostrarArco}
      mostrarPosicaoInicial={sobreposicoes.mostrarPosicaoInicial}
      eixoColuna={extracao.eixoColuna}
      orientacaoSeta={orientacaoSeta}
      mostrarSetaCervical={sobreposicoes.mostrarSetaCervical}
      ferramenta={ferramentaExtracao}
      pontosRotaLivre={pontosRotaLivre.length}
      obstaculosExternos={obstaculosExternos}
      idsObstaculosInterferindo={extracao.obstaculosExternosInterferindo.map((item) => item.id)}
      vitimasInterferindo={extracao.vitimasSecundarias.filter((item) => item.interfere).map((item) => ({ id: item.id, nome: item.nome }))}
      prioridadePendente={extracao.prioridadePendente}
      aoAlterarOrientacaoSeta={setOrientacaoSeta}
      aoAlternarSetaCervical={(valor) => setSobreposicoes((estado) => ({ ...estado, mostrarSetaCervical: valor }))}
      aoAlinharSetaComRota={() => setOrientacaoSeta(orientacaoDaRota(extracao.eixoColuna, extracao.rota))}
      aoTrocarModo={(novoModo) => {
        setModoRota(novoModo)
        setFerramentaExtracao('nenhuma')
        setIdComparada(null)
        timeline.reiniciar()
      }}
      aoEscolherAbertura={(id) => {
        setIdAbertura(id)
        if (idComparada === id) setIdComparada(null)
        timeline.reiniciar()
      }}
      aoEscolherAngulo={(angulo) => {
        setAnguloSelecionado(angulo)
        if (idComparada === String(angulo)) setIdComparada(null)
        timeline.reiniciar()
      }}
      aoComparar={setIdComparada}
      aoAlternarPrancha={(valor) => {
        setComPrancha(valor)
        timeline.reiniciar()
      }}
      aoAlternarConceito={setModoConceito}
      aoAlternarVerInterior={setVerInteriorExtracao}
      aoEscolherTeto={setEstadoTeto}
      aoEscolherConfiguracao={(novaConfiguracao) => {
        if (novaConfiguracao === 'lateral' || novaConfiguracao === 'invertido') {
          setIdAbertura('tampaTraseira')
          setAnguloSelecionado(0)
          if (idComparada === 'tampaTraseira' || idComparada === '0') setIdComparada(null)
        }
        if (novaConfiguracao !== 'sobreRodas') setComPrancha(true)
        setConfiguracao(novaConfiguracao)
        timeline.reiniciar()
      }}
      aoEscolherDecubito={(novoDecubito) => {
        setDecubito(novoDecubito)
        timeline.reiniciar()
      }}
      aoEscolherSentidoCabeca={(sentido) => {
        setSentidoCabeca(sentido)
        timeline.reiniciar()
      }}
      aoAgirNoObstaculo={executarAcao}
      aoAlternar={(chave, valor) => setSobreposicoes((estado) => ({ ...estado, [chave]: valor }))}
      aoEscolherFerramenta={setFerramentaExtracao}
      aoLimparTrajeto={() => {
        setPontosRotaLivre([])
        timeline.reiniciar()
      }}
      aoLimparObstaculosExternos={() => setObstaculosExternos([])}
    />
  )

  const painelCamadas = (
    <PainelCamadas
      camadas={camadas}
      opacidadeCarroceria={opacidadeCarroceria}
      mostrarRotulos={mostrarRotulos}
      pinturaPorAco={pinturaPorAco}
      depuracaoHit={depuracaoHit}
      aoAlternarPinturaPorAco={setPinturaPorAco}
      aoAlternarCamada={(chave) => setCamadas((estado) => ({ ...estado, [chave]: !estado[chave] }))}
      aoMudarOpacidade={setOpacidadeCarroceria}
      aoAlternarRotulos={setMostrarRotulos}
      aoAlternarDepuracaoHit={setDepuracaoHit}
    />
  )

  const colocacaoEstabilizacaoSelecionada = colocacoesEstabilizacao.find(
    (item) => item.id === idColocacaoEstabilizacaoSelecionada,
  ) ?? null
  /* A construção dos grupos, chips, ações rápidas e inspetor de cada módulo vive
     em `apresentacao/modulos/`. Aqui fica só a ligação com o estado: os painéis
     chegam prontos, e o manifesto diz como apresentá-los. Antes eram 420 linhas
     de `if (aba === …) else if (…)` neste arquivo. */
  const ferramentas: FerramentasModulo =
    aba === 'maquete'
      ? ferramentasEstrutura({
          painelAnatomia: () => (
            <PainelAnatomia
              perfil={perfil}
              selecionada={selecionada}
              aoInspecionar={inspecionarPecaAnatomia}
              etapa={etapaAnatomia}
              concluidas={etapasAnatomiaConcluidas}
              aoEscolher={prepararEtapaAnatomia}
              aoConcluir={(id) => setEtapasAnatomiaConcluidas((lista) => lista.includes(id) ? lista : [...lista, id])}
              tipoEstrutura={tipoEstrutura}
              aoEscolherTipoEstrutura={setTipoEstrutura}
              explodido={explodido}
              aoMudarExplodido={setExplodido}
              airbags={camadas.srs
                ? { expansao: expansaoAirbagAnatomia, aoMudarExpansao: mudarExpansaoAirbagAnatomia, aoDeflagrar: deflagrarAirbagsAnatomia }
                : undefined}
            />
          ),
          painelDetalhes: () => (
            <PainelDetalhes
              id={selecionada}
              estado={estadoDe(estadosEfetivos, selecionada ?? '')}
              aoExecutar={executarAcao}
              aoSelecionar={setSelecionada}
              aoFocar={(alvo) => camera.executar('enquadrarSelecao', alvo)}
              aoLimpar={() => setSelecionada(null)}
            />
          ),
          painelCamadas: () => painelCamadas,
          painelCena: () => painelCena,
          legenda: () => <Legenda pinturaPorAco={pinturaPorAco} />,
          nomeVeiculo: perfil.nome,
          etapaAnatomia,
          quantidadeSrs,
          selecao: selecionada
            ? {
                id: selecionada,
                nome: componenteDidatico(selecionada)?.nome ?? selecionada,
                classificacao: componenteDidatico(selecionada)?.descricao,
                estado: estadoDe(estadosEfetivos, selecionada),
                acoes: acoesDisponiveis(selecionada).map((acao) => (
                  <button
                    key={acao}
                    type="button"
                    className="btn-acao-cad btn-acao-cad--primario"
                    onClick={() => executarAcao(selecionada, acao)}
                  >
                    {rotuloAcao(acao)}
                  </button>
                )),
              }
            : null,
          aoLimparSelecao: () => setSelecionada(null),
          modo,
          aoAplicarModo: aplicarModo,
          explodido,
          aoMudarExplodido: setExplodido,
        })
      : aba === 'cinematica'
        ? ferramentasCinematica({
            painelEvento: () => <>{renderPainelCinematica(['evento'])}{painelCena}</>,
            painelOcupantes: () => (
              <PainelOcupantes
                perfil={perfil}
                ocupantes={ocupantes}
                idFoco={idFocoCinematica}
                aoAdicionar={adicionarOcupante}
                aoRemover={removerOcupante}
                aoAlterarRetencao={alterarRetencaoOcupante}
                aoFocar={setIdFocoCinematica}
              />
            ),
            aoAbrirQuatroImpactos: () => {
              timeline.irPara(timeline.tempo)
              setGrupoRibbonAtivo(null)
              setMostrarQuatroImpactos(true)
            },

            painelSobreposicoes: () => <>{renderPainelCinematica(['sobreposicoes'])}{painelCamadas}</>,
            painelReproducao: () => <ControlesTimeline timeline={timeline} fase={quadro.fase} />,
            painelResultados: () => <>{renderPainelCinematica(['resultados'])}<Legenda pinturaPorAco={pinturaPorAco} /></>,
            quantidadeOcupantes: ocupantes.length,
            fase: quadro.fase,
            velocidadeKmh: velocidadeImpacto,
            deltaVKmh: calcularDeltaV(tipoColisao, alvoImpacto, velocidadeImpacto, {
              ehEV: perfil.energia.propulsao === 'eletrico' || perfil.energia.propulsao === 'hibrido',
              ehBlindado: veiculoBlindado,
            }).deltaVKmh,
            classificacaoDeltaV: calcularDeltaV(tipoColisao, alvoImpacto, velocidadeImpacto, {
              ehEV: perfil.energia.propulsao === 'eletrico' || perfil.energia.propulsao === 'hibrido',
              ehBlindado: veiculoBlindado,
            }).classificacao,
            reproduzindo: timeline.reproduzindo,
            aoAlternarReproducao: timeline.alternarReproducao,
            aoReiniciar: () => timeline.reiniciar(),
            lataSolida: lataSolidaCinematica,
            aoAlternarLataSolida: setLataSolidaCinematica,
            ocupanteEmFoco: ocupanteFocoCinematica && {
              id: ocupanteFocoCinematica.id,
              nome: ocupanteFocoCinematica.nome,
              tipo: ocupanteFocoCinematica.tipo === 'pessoa' ? 'Ocupante' : 'Carga solta',
              posicao: ancoraPorId(perfil, ocupanteFocoCinematica.idAncora).nome,
              retencao: ocupanteFocoCinematica.retencao === 'comCinto' ? 'com cinto' : 'sem cinto',
              reacao: reacaoFocoCinematica?.contato
                ? `contato em ${reacaoFocoCinematica.contato.superficie}`
                : reacaoFocoCinematica?.retido
                  ? 'retido pelo cinto'
                  : undefined,
            },
            rotuloOrigem: moduloCinematicaOrigem ? moduloPorId(moduloCinematicaOrigem).rotulo : undefined,
            aoVoltar: voltarDaCinematica,
          })
        : aba === 'estabilizacao'
          ? ferramentasEstabilizacao({
              painelCenario: () => <>{renderPainelEstabilizacao(['cenario'])}{painelCena}</>,
              painelSuspensao: () => renderPainelEstabilizacao(['suspensao']),
              painelMontagem: () => <PainelMontagemEstabilizacao montagem={montagemEstabilizacao} aoEscolherNaCena={() => setGrupoRibbonAtivo(null)} />,
              montagemNoInspetor: modoLayout !== 'mobile',
              aoAbrirMontagem: () => { if (modoLayout === 'mobile') setGrupoRibbonAtivo('montagem'); else { setInspetorRecolhido(false); setAbaInspetorCAD('operacao') } },
              painelVisualizacao: () => <>{renderPainelEstabilizacao(['visualizacao'])}{painelCamadas}<Legenda pinturaPorAco={pinturaPorAco} /></>,
              quantidadeApoios: colocacoesEstabilizacao.length,
              progresso: avaliacaoEstabilizacao.progresso,
              secundariaConcluida: avaliacaoEstabilizacao.secundariaConcluida,
              suspensaoAnulada: avaliacaoEstabilizacao.suspensaoAnulada,
              aoPerturbar: perturbarQuatroCantos,
              perturbando,
              aoLimparApoios: () => {
                setColocacoesEstabilizacao([])
                setIdColocacaoEstabilizacaoSelecionada(null)
              },
              apoioSelecionado: colocacaoEstabilizacaoSelecionada
                ? {
                    id: colocacaoEstabilizacaoSelecionada.id,
                    nome: EQUIPAMENTOS_ESTABILIZACAO[colocacaoEstabilizacaoSelecionada.equipamento].nome,
                    equipamento: EQUIPAMENTOS_ESTABILIZACAO[colocacaoEstabilizacaoSelecionada.equipamento].nome,
                    rotacaoGraus: Math.round((((colocacaoEstabilizacaoSelecionada.rotacaoGraus ?? 0) % 360) + 360) % 360),
                    comCunhaAjuste: colocacaoEstabilizacaoSelecionada.comCunhaAjuste ?? false,
                    ehCalco: colocacaoEstabilizacaoSelecionada.equipamento === 'calco',
                    ehBloco: colocacaoEstabilizacaoSelecionada.equipamento === 'bloco',
                    ehLigacao: colocacaoEstabilizacaoSelecionada.equipamento === 'fitaCatraca',
                    invertido: colocacaoEstabilizacaoSelecionada.invertido ?? false,
                    aoGirar: (graus: number) => atualizarColocacaoEstabilizacao(
                      colocacaoEstabilizacaoSelecionada.id,
                      { rotacaoGraus: ((graus % 360) + 360) % 360 },
                    ),
                    aoAlternarCunha: () => atualizarColocacaoEstabilizacao(
                      colocacaoEstabilizacaoSelecionada.id,
                      { comCunhaAjuste: !colocacaoEstabilizacaoSelecionada.comCunhaAjuste },
                    ),
                    aoInverter: () => atualizarColocacaoEstabilizacao(
                      colocacaoEstabilizacaoSelecionada.id,
                      { invertido: !colocacaoEstabilizacaoSelecionada.invertido },
                    ),
                    aoRemover: () => removerEquipamentoEstabilizacao(colocacaoEstabilizacaoSelecionada.id),
                  }
                : null,
              aoLimparSelecao: () => setIdColocacaoEstabilizacaoSelecionada(null),
            })
          : aba === 'corte'
            ? ferramentasCorte({
                painelCenario: () => <>{renderPainelCorte(['cenario'])}{painelCena}</>,
                painelReforcos: () => <>{renderPainelCorte(['reforcos'])}{painelCamadas}<Legenda pinturaPorAco={pinturaPorAco} /></>,
                painelTecnica: () => renderPainelCorte(['tecnica']),
                configuracao: configuracaoCorte,
                player: playerCorte,
                modo: modoOficinaCorte,
                aoMudarModo: setModoOficinaCorte,
                ferramenta: ferramentaCorte,
                modoAlargador,
                motivoDaFerramenta: motivoDaFerramentaDeCorte,
                acoesDePreparo: acoesDePreparoDaPeca,
                incluirPreparo: true,
                aoEscolherFerramenta: escolherFerramentaCorte,
                aoEscolherModoAlargador: escolherModoAlargador,
                vinculosRestantes: vinculosRestantes(estadoPortaCorte).length,
                aoReiniciarPratica: resetarEstadosOficinaCorte,
              })
            : aba === 'tabletop'
              ? ferramentasTabletop({
                  painelRoteiroAula: renderRoteiroAula,
                  secaoAtiva: secaoTabletop,
                  aoAtivarSecao: (secao) => {
                    tabletop.cancelarPosicionamento()
                    setSecaoTabletop(secao)
                    setInspetorRecolhido(false)
                    setGrupoRibbonAtivo(null)
                    setAbaInspetorCAD('operacao')
                  },
                  modoRoteiroAula: true,
                  asfaltoAtivo: tabletop.asfaltoAtivo,
                  aoAlternarAsfalto: tabletop.alternarAsfalto,
                  cenarioTravado: tabletop.cenarioTravado,
                  aoAlternarTravaCenario: tabletop.alternarTravaCenario,
                  encaixeAtivo: encaixeTabletopAtivo,
                  aoAlternarEncaixe: () => setEncaixeTabletopAtivo((ativo) => !ativo),
                  painelAdicionar: () => renderPainelTabletop(['adicionar']),
                  painelFerramentas: () => renderPainelTabletop(['ferramentas']),
                  painelFila: () => renderPainelTabletop(['fila']),
                  painelObjetos: () => renderPainelTabletop(['objetos']),
                  painelCena: () => renderPainelTabletop(['cena']),
                  painelIo: () => renderPainelTabletop(['io']),
                  painelEditor: () => renderPainelTabletop(['editor']),
                  quantidadeObjetos: tabletop.cena.objetos.length,
                  quantidadeFila: tabletop.fila.length,
                  quantidadeVitimas: tabletop.cena.objetos.filter((o) => o.tipo === 'vitima').length,
                  modo: tabletop.modo,
                  aoDefinirModo: tabletop.definirModo,
                  ferramenta: tabletop.ferramenta,
                  aoEscolherFerramenta: tabletop.escolherFerramenta,
                  desfazer: tabletop.desfazer,
                  refazer: tabletop.refazer,
                  podeDesfazer: tabletop.podeDesfazer,
                  podeRefazer: tabletop.podeRefazer,
                  objetoSelecionado: tabletop.objetoSelecionado
                    ? {
                        id: tabletop.objetoSelecionado.id,
                        nome: tabletop.objetoSelecionado.nome,
                        tipo: tabletop.objetoSelecionado.tipo,
                        posicao: tabletop.objetoSelecionado.transformacao.posicao,
                        rotacaoGraus: Math.round(
                          (tabletop.objetoSelecionado.transformacao.rotacao[1] * 180) / Math.PI,
                        ),
                        escala: tabletop.objetoSelecionado.transformacao.escala[0],
                        oculto: tabletop.objetoSelecionado.oculto ?? false,
                        bloqueado: tabletop.objetoSelecionado.bloqueado ?? false,
                        aoDuplicar: () => tabletop.duplicar(tabletop.objetoSelecionado!.id),
                        aoRestaurar: () => tabletop.resetarTransformacao(tabletop.objetoSelecionado!.id),
                        aoRemover: () => tabletop.remover(tabletop.objetoSelecionado!.id),
                      }
                    : null,
                  aoLimparSelecao: () => tabletop.selecionar(null),
                })
              : ferramentasExtracao({
                  area: areaExtracao,
                  aoEscolherArea: (area) => {
                    setAreaExtracao(area)
                    setGrupoRibbonAtivo(null)
                  },
                  painelOficina: () => <p>Escolha uma vítima e registre, item a item, o que a equipe pede na Oficina de Vítimas.</p>,
                  painelDecisao: () => (
                    <PainelDecisaoExtracao
                      sessao={sessaoExtracao.sessao}
                      comparacaoGeometria={procedimentosFeitos.length === 0 ? [] : [{
                        rotulo: 'Espaço real da rota atual',
                        antes: `${(extracao.folgaAntesDosProcedimentos * 100).toFixed(0)} cm · ${extracao.obstaculosAntesDosProcedimentos.filter((item) => item.interfere).length} obstáculo(s)`,
                        depois: `${(extracao.folgaDepoisDosProcedimentos * 100).toFixed(0)} cm · ${extracao.obstaculos.filter((item) => item.interfere).length} obstáculo(s)`,
                        efeito: 'Valores derivados de obstaculosDaRota/folgaMinima com e sem os procedimentos executados.',
                      }]}
                      estrategia={{
                        abertura: aberturaPorId(perfil, idAbertura).nome,
                        giroGraus: extracao.rota.resultado.desvioDoEixoGraus,
                        folgaCm: extracao.folgaDepoisDosProcedimentos * 100,
                        obstaculos: extracao.obstaculos.filter((item) => item.interfere).length + extracao.obstaculosExternosInterferindo.length,
                        interferenciaVitima: extracao.vitimasSecundarias.some((item) => item.interfere),
                      }}
                      aoEscolherModo={(modoExperiencia) => {
                        sessaoExtracao.escolherModo(modoExperiencia)
                        if (modoExperiencia === 'cenario') carregarFocoDoCenario(sessaoExtracao.sessao.cenario.id, sessaoExtracao.sessao.vitimaFocoId)
                      }}
                      aoEscolherCenario={escolherCenarioExtracao}
                      aoNavegar={sessaoExtracao.navegar}
                      aoFocarVitima={focarVitimaCenario}
                      aoAvaliar={sessaoExtracao.avaliar}
                      aoJustificar={sessaoExtracao.justificar}
                      aoPreparar={sessaoExtracao.preparar}
                      aoDecidirMomento={sessaoExtracao.decidirMomento}
                      aoEscolherOrdem={sessaoExtracao.escolherOrdem}
                      aoEnquadrarAcao={() => camera.executar('alinhamentoVitimaPrancha', idFocoExtracao)}
                      cenariosAutorais={cenariosAutorais.lista.map((item) => ({ id: item.id, nome: item.cenario.nome }))}
                      aoDeclararClassificacao={sessaoExtracao.declararClassificacao}
                      aoDeclararAtencaoInicial={sessaoExtracao.declararAtencaoInicial}
                      aoLiberarDebriefing={sessaoExtracao.liberarDebriefing}
                      referenciaCorrecao={cenariosAutorais.lista.find((item) => item.id === sessaoExtracao.sessao.cenario.id)?.referencia}
                    />
                  ),
                  painelVitimas: () => (
                    <PainelOcupantes
                      perfil={perfil}
                      ocupantes={vitimasPorPrioridade(ocupantes)}
                      idFoco={idFocoExtracao}
                      aoAdicionar={adicionarOcupante}
                      aoRemover={removerOcupante}
                      aoAlterarRetencao={alterarRetencaoOcupante}
                      aoAlterarEstadoClinico={alterarEstadoClinico}
                      aoFocar={sessaoExtracao.sessao.modo === 'cenario' ? focarVitimaCenario : focarVitimaExtracao}
                      modoClinico
                    />
                  ),
                  painelPosicao: () => <>{renderPainelExtracao(['posicao'])}{painelCena}</>,
                  painelRota: () => renderPainelExtracao(['rota']),
                  painelObstaculos: () => renderPainelExtracao(['obstaculos']),
                  painelTecnica: () => renderPainelExtracao(['tetoTecnica']),
                  painelProcedimentos: () => (
                    <PainelProcedimentos
                      perfil={perfil}
                      idAncoraFoco={idAncora}
                      feitos={procedimentosFeitos}
                      idAbertura={saidaPelaTraseira ? 'tampaTraseira' : idAbertura}
                      aoAlternar={alternarProcedimento}
                      efeito={extracao.efeitoUltimaAcao}
                      mostrarPosicaoAnterior={mostrarPosicaoAnteriorBanco}
                      aoAlternarMostrarPosicaoAnterior={setMostrarPosicaoAnteriorBanco}
                    />
                  ),
                  painelAutoria: () => (
                    <PainelAutoriaCenario
                      autorais={cenariosAutorais}
                      cenariosCatalogo={CENARIOS_EXTRACAO}
                      aoPreVisualizarComoAluno={(id) => {
                        escolherCenarioExtracao(id)
                        setGrupoRibbonAtivo(null)
                      }}
                    />
                  ),
                  painelSobreposicoes: () => <>{renderPainelExtracao(['sobreposicoes'])}{painelCamadas}</>,
                  painelReproducao: () => <ControlesTimeline timeline={timeline} fase={faseAnimacaoExtracao} marcos={marcosAnimacaoExtracao} />,
                  painelResultados: () => <>{renderPainelExtracao(['resultados'])}<Legenda pinturaPorAco={pinturaPorAco} /></>,
                  quantidadeVitimas: vitimasPorPrioridade(ocupantes).length,
                  quantidadeObstaculos: extracao.obstaculos.length + obstaculosExternos.length,
                  modoRota,
                  desvioGraus: leituraDaRota(extracao.rota).axial ? 0 : leituraDaRota(extracao.rota).exatoGraus,
                  prioridadePendente: extracao.prioridadePendente,
                  modoExperiencia: sessaoExtracao.sessao.modo,
                  etapaDecisao: sessaoExtracao.sessao.etapa,
                  reproduzindo: timeline.reproduzindo,
                  aoAlternarReproducao: timeline.alternarReproducao,
                  aoReiniciar: () => timeline.reiniciar(),
                  vitimaEmFoco: (() => {
                    const vitima = ocupantePorId(ocupantes, idFocoExtracao)
                    if (!vitima) return null
                    return {
                      id: vitima.id,
                      nome: vitima.nome,
                      estadoClinico: vitimaSeveridadeVisivel(sessaoExtracao.sessao, vitima.id)
                        ? vitima.estadoClinico ?? 'não triada'
                        : 'a avaliar',
                      retencao: vitima.retencao === 'comCinto' ? 'com cinto' : 'sem cinto',
                      posicao: ancoraPorId(perfil, vitima.idAncora).nome,
                      abertura: aberturaPorId(perfil, idAbertura).nome,
                      procedimentosFeitos: procedimentosFeitos.length,
                      procedimentosTotal: IDS_PROCEDIMENTO.length,
                    }
                  })(),
                })


  /* Estado de relance, no rodapé: módulo, o que está selecionado e se a
     simulação está rodando. Antes só dava para responder isso abrindo um grupo
     da ribbon. Cada item leva ícone além da cor. */
  const nomeSelecionado = aba === 'tabletop'
    ? tabletop.objetoSelecionado?.nome
    : aba === 'estabilizacao'
      ? colocacaoEstabilizacaoSelecionada
        && EQUIPAMENTOS_ESTABILIZACAO[colocacaoEstabilizacaoSelecionada.equipamento].nome
      : aba === 'corte'
        ? ferramentaCorte
        : aba === 'maquete'
          ? selecionada && (componenteDidatico(selecionada)?.nome ?? selecionada)
          : aba === 'cinematica'
            ? ocupanteFocoCinematica?.nome
            : aba === 'extracao'
              ? ocupantePorId(ocupantes, idFocoExtracao)?.nome
              : undefined

  const IconeDoModulo = moduloPorId(aba).Icone
  const itensEstado: ItemEstado[] = [
    {
      id: 'modulo',
      rotulo: 'Módulo',
      valor: TITULOS[aba],
      icone: <IconeDoModulo />,
      tom: 'info',
    },
    {
      id: 'selecao',
      rotulo: 'Seleção',
      valor: nomeSelecionado ?? 'nada selecionado',
      icone: nomeSelecionado ? <IconeSelecao /> : <IconePonto />,
    },
  ]

  if (ultimoHit) {
    itensEstado.push({
      id: 'inspecao-hit',
      rotulo: 'Hit',
      valor: `${ultimoHit.pecaId} (${ultimoHit.lado})`,
      titulo: `Ponto local: [${ultimoHit.pontoLocal.map((c) => c.toFixed(2)).join(', ')}] • Ponto mundo: [${ultimoHit.pontoMundo.map((c) => c.toFixed(2)).join(', ')}]`,
      icone: <IconePonto />,
      tom: 'info',
    })
  }

  if (aba === 'cinematica' || aba === 'extracao') {
    itensEstado.push({
      id: 'simulacao',
      rotulo: 'Simulação',
      valor: timeline.reproduzindo ? 'rodando' : 'pausada',
      icone: timeline.reproduzindo ? <IconeReproduzir /> : <IconePausar />,
      tom: timeline.reproduzindo ? 'sucesso' : 'neutro',
    })
  }

  if (aba === 'estabilizacao') {
    itensEstado.push({
      id: 'ferramenta-estabilizacao',
      rotulo: 'Ferramenta',
      valor:
        ferramentaEstabilizacao === 'selecao'
          ? 'Ponteiro (Seleção)'
          : EQUIPAMENTOS_ESTABILIZACAO[ferramentaEstabilizacao].nome,
      icone: ferramentaEstabilizacao === 'selecao' ? <IconeSelecao /> : <IconeCalco />,
      tom: 'info',
    })
  }

  if (aba === 'corte') {
    if (modoOficinaCorte === 'demonstracao') {
      itensEstado.push({
        id: 'etapa-corte',
        rotulo: 'Etapa',
        valor: `${playerCorte.indiceEtapa + 1}/${playerCorte.tecnica.etapas.length} • ${playerCorte.etapaAtual.titulo}`,
        icone: <IconeFerramenta />,
        tom: 'info',
        flexivel: true,
      })
      itensEstado.push({
        id: 'simulacao-corte',
        rotulo: 'Demonstração',
        valor: playerCorte.reproduzindo ? 'reproduzindo' : playerCorte.estadoAnimacao === 'concluido' ? 'concluída' : 'pausada',
        icone: playerCorte.reproduzindo ? <IconeReproduzir /> : <IconePausar />,
        tom: playerCorte.reproduzindo ? 'sucesso' : 'neutro',
      })
    } else {
      const ferramentaObj = FERRAMENTAS_DE_INTERVENCAO.find((f) => f.id === ferramentaCorte)
      itensEstado.push({
        id: 'ferramenta-corte',
        rotulo: 'Ferramenta',
        valor: ferramentaObj?.nomeCurto ?? ferramentaCorte,
        icone: ferramentaObj ? <ferramentaObj.Icone /> : <IconeFerramenta />,
        tom: 'info',
      })
      itensEstado.push({
        id: 'vinculos-corte',
        rotulo: 'Vínculos',
        valor: estadoPortaCorte.removida ? 'Porta removida' : `${vinculosRestantes(estadoPortaCorte).length} restantes`,
        tom: estadoPortaCorte.removida ? 'sucesso' : vinculosRestantes(estadoPortaCorte).length === 0 ? 'sucesso' : 'alerta',
      })
      itensEstado.push({
        id: 'interacao-corte',
        rotulo: 'Status',
        valor: mensagemInteracaoCorte,
        flexivel: true,
      })
    }
  }

  /* Só o CENÁRIO, sem o nome do módulo: ele já aparece aceso na navegação e por
     extenso na barra de estado, e repeti-lo aqui custava a largura que os grupos
     e as ações rápidas precisam. */
  const identificadorCenario = (
    <div className="cenario-identificador-compacto">
      <span className="cenario-identificador-compacto__sub">
        {aba === 'tabletop'
          ? `${tabletop.cena.nome} • ${tabletop.cena.objetos.length} objeto(s)`
          : `${perfil.nome} • ${aba === 'cinematica' ? colisao(tipoColisao).nome : aba === 'estabilizacao' ? 'Treinamento por posição final' : cenario.nome}`}
      </span>
    </div>
  )

  // Janela de projeção (2ª tela / sala de aula): tela limpa e somente leitura,
  // alimentada só pelo estado PÚBLICO que a janela do instrutor transmite
  // (`montarEstadoPublico`) — o gabarito nunca chega aqui.
  if (ehJanelaDeProjecao()) {
    return <TelaProjecaoTabletop />
  }

  return (
    <Workspace
      tema={tema}
      modoLayout={modoLayout}
      barraAplicacao={
        <BarraAplicacao
          moduloAtual={aba}
          aoTrocarModulo={trocarAba}
          tema={tema}
          aoAlternarTema={() => setTema((atual) => (atual === 'claro' ? 'escuro' : 'claro'))}
          modoLayout={modoLayout}
        />
      }
      ribbon={
        modoLayout === 'mobile' || mostrarCenaGuiada || mostrarOficinaVitimas ? null : (
        <BarraFerramentasCenario
          titulo={`Ferramentas de ${TITULOS[aba]}`}
          identificadorCenario={identificadorCenario}
          grupos={ferramentas.grupos}
          grupoAtivo={grupoRibbonAtivo}
          aoMudarGrupo={setGrupoRibbonAtivo}
          chips={ferramentas.chips}
          acoesRapidas={ferramentas.acoesRapidas}
          chaveContexto={aba}
        />
        )
      }
      dock={
        modoLayout === 'mobile' && !mostrarCenaGuiada && !mostrarOficinaVitimas ? (
          <DockMobile
            grupos={ferramentas.grupos}
            grupoAtivo={grupoRibbonAtivo}
            aoMudarGrupo={setGrupoRibbonAtivo}
            tituloModulo={TITULOS[aba]}
            acoesRapidas={ferramentas.acoesRapidas}
            inspetor={ferramentas.inspetor ?? null}
            ferramentas={aba === 'tabletop' && secaoTabletop === 'estabilizacao'
              ? ([
                  { id: 'selecao-tabletop', rotulo: 'Selecionar', Icone: IconeSelecao, ativa: tabletop.tipoParaPosicionar == null, aoAcionar: () => tabletop.cancelarPosicionamento() },
                  ...([
                    ['calco', 'Calço', IconeCalco], ['bloco', 'Bloco', IconeBloco], ['cunha', 'Cunha', IconeCunha],
                    ['fitaCatraca', 'Fita catraca', IconeFitaCatraca], ['vstrut', 'V-Strut', IconeVStrut],
                  ] as const).map(([tipo, rotulo, Icone]) => ({ id: `tabletop-${tipo}`, rotulo, Icone,
                    ativa: tabletop.tipoParaPosicionar === tipo,
                    motivoIndisponivel: tabletop.cena.objetos.some(o => o.veiculo) ? undefined : 'Adicione um veículo antes de posicionar equipamentos',
                    aoAcionar: () => iniciarEquipamentoTabletop(tipo) })),
                ] as FerramentaDaTrilha[])
              : aba === 'estabilizacao' ? gruposExtrasEstabilizacao[0]!.ferramentas : undefined}
          />
        ) : undefined
      }
      canvas={
        mostrarQuatroImpactos
          ? <PainelQuatroImpactos aoVoltar={() => setMostrarQuatroImpactos(false)} />
          : aba === 'extracao' && areaExtracao === 'oficina'
          ? <OficinaVitimas estado={estadoOficinaVitimas} aoVerCinematica={aplicarCinematicaDaVitima}
              aoVoltarRetirada={() => { setAreaExtracao('retirada'); setGrupoRibbonAtivo(null) }} />
          : (
        <>
      <Visualizador3D
        comandoCamera={camera.comando}
        aoInteragirCameraOficina={playerCorte.tornarCameraManual}
        demonstracaoOficina={
          aba === 'corte' && modoOficinaCorte === 'demonstracao'
            ? {
                executando: playerCorte.faseVisual === 'executando',
                recuando: playerCorte.faseVisual === 'recuando',
                pausado: playerCorte.estadoAnimacao === 'pausado',
                concluida: playerCorte.estadoAnimacao === 'concluido',
              }
            : undefined
        }
        contexto={contexto}
        maquete={{
          mostrarDetalhesAnatomia: aba === 'maquete',
          idPerfilVitima,
          idAncora,
          mostrarVitima: aba !== 'maquete' && mostrarVitima,
          mostrarEixoColuna: sobreposicoes.mostrarEixoColuna && camadas.vitima,
          tipoEstrutura,
          mostrarComparacaoEstrutural: etapaAnatomia === 'estrutura',
          oficinaPorta: aba === 'corte' && pecaOficinaCorte === 'porta'
            ? {
                id: vidroCorte as IdPortaOficina,
                estado: estadoPortaCorte,
                progressoSaida: progressoSaidaPortaCorte,
                progressoAcao: modoOficinaCorte === 'demonstracao'
                  ? (playerCorte.faseVisual === 'executando' ? playerCorte.progressoFerramenta : 0)
                  : progressoFerramentaCorte,
                operacaoVisual: modoOficinaCorte === 'demonstracao'
                  ? playerCorte.etapaAtual.operacaoPorta
                  : operacaoPortaCorte,
              }
            : undefined,
          oficinaTampa: aba === 'corte' && pecaOficinaCorte === 'tampaTraseira'
            ? { estado: estadoTampaCorte }
            : undefined,
          oficinaTerceiraPorta: aba === 'corte' && pecaOficinaCorte === 'terceiraPorta'
            ? { lado: ladoTerceiraPortaCorte, estado: estadoTerceiraPortaCorte }
            : undefined,
          oficinaExtensor: aba === 'corte'
            ? { deslocamentoPainel: oficina.estadoExtensorVisual.deslocamentoPainel, rebatimento: oficina.estadoExtensorVisual.rebatimento, elevacao: oficina.estadoExtensorVisual.elevacao, tetoLateral: oficina.estadoExtensorVisual.tetoLateral, idPorta: idPortaCorte }
            : undefined,
        }}
        oficinaCorte={{
          ativa: aba === 'corte' && pecaOficinaCorte === 'porta',
          configuracao: configuracaoCorte,
          ferramenta: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.etapaAtual.ferramenta === 'nenhuma'
                ? 'cortadorHidraulico'
                : playerCorte.etapaAtual.ferramenta)
            : ferramentaCorte,
          modoAlargador: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.etapaAtual.modoAlargador ?? 'abrir')
            : modoAlargador,
          progresso: modoOficinaCorte === 'demonstracao'
            ? playerCorte.progressoFerramenta
            : progressoFerramentaCorte,
          progressoEstrutural: progressoEstruturalPortas[idPortaCorte],
          idPorta: vidroCorte as IdPortaOficina,
          zonaSelecionada: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.zonaEmDestaque ? (playerCorte.etapaAtual.zonaAlvo as IdZonaOperacaoPorta | IdZonaRebatimentoPainel | IdZonaElevacaoPainel | IdZonaTetoLateral) : null)
            : zonaOperacaoCorte,
          estado: estadoPortaCorte,
          ajusteFerramenta: modoOficinaCorte === 'demonstracao'
            ? ajusteFerramentaPlayerCorte
            : ajusteFerramentaCorte,
          afastamento: modoOficinaCorte === 'demonstracao'
            ? playerCorte.afastamentoFerramenta
            : (segurandoFerramentaCorte ? 0 : 0.08),
          ferramentaVisivel: modoOficinaCorte === 'demonstracao'
            ? playerCorte.ferramentaVisivel
            : (zonaOperacaoCorte !== null && ferramentaCorte !== 'vstrut' && ferramentaCorte !== 'calcoEscalonado' && ferramentaCorte !== 'blocoCribbing'),
          preparo: modoOficinaCorte === 'demonstracao' ? playerCorte.preparoFerramenta : 1,
          estadoInicial: modoOficinaCorte === 'demonstracao' ? playerCorte.estadoInicialFerramenta : null,
          deslizar: modoOficinaCorte === 'demonstracao',
          desabilitarArraste: true,
          ...interacaoPorta,
          extensor: {
            estado: oficina.estadoExtensorVisual,
            progresso: progressoEstruturalExtensor,
            aoEscolherApoio: () => {},
            aoPrevisualizarApoio: () => {},
          },
        }}
        oficinaTampa={{
          ativa: aba === 'corte' && pecaOficinaCorte === 'tampaTraseira',
          configuracao: configuracaoCorte,
          ferramenta: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.etapaAtual.ferramenta === 'nenhuma'
                ? 'cortadorHidraulico'
                : playerCorte.etapaAtual.ferramenta)
            : ferramentaCorte,
          progresso: modoOficinaCorte === 'demonstracao' ? playerCorte.progressoFerramenta : progressoFerramentaCorte,
          progressoEstrutural: progressoEstruturalTampa,
          zonaSelecionada: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.zonaEmDestaque ? (playerCorte.etapaAtual.zonaAlvo as IdZonaOperacaoTampa) : null)
            : zonaOperacaoTampaCorte,
          estado: estadoTampaCorte,
          ajusteFerramenta: modoOficinaCorte === 'demonstracao' ? ajusteFerramentaPlayerCorte : ajusteFerramentaTampaCorte,
          afastamento: modoOficinaCorte === 'demonstracao' ? playerCorte.afastamentoFerramenta : (segurandoFerramentaCorte ? 0 : 0.08),
          ferramentaVisivel: modoOficinaCorte === 'demonstracao' ? playerCorte.ferramentaVisivel : (zonaOperacaoTampaCorte !== null),
          preparo: modoOficinaCorte === 'demonstracao' ? playerCorte.preparoFerramenta : 1,
          estadoInicial: modoOficinaCorte === 'demonstracao' ? playerCorte.estadoInicialFerramenta : null,
          deslizar: modoOficinaCorte === 'demonstracao',
          desabilitarArraste: true,
          ...interacaoTampa,
        }}
        oficinaTerceiraPorta={{
          ativa: aba === 'corte' && pecaOficinaCorte === 'terceiraPorta',
          configuracao: configuracaoCorte,
          ferramenta: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.etapaAtual.ferramenta === 'nenhuma'
                ? 'cortadorHidraulico'
                : playerCorte.etapaAtual.ferramenta)
            : ferramentaCorte,
          progresso: modoOficinaCorte === 'demonstracao' ? playerCorte.progressoFerramenta : progressoFerramentaCorte,
          progressoEstrutural: progressoEstruturalTerceirasPortas[ladoTerceiraPortaCorte],
          lado: ladoTerceiraPortaCorte,
          zonaSelecionada: modoOficinaCorte === 'demonstracao'
            ? (playerCorte.zonaEmDestaque ? (playerCorte.etapaAtual.zonaAlvo as IdZonaOperacaoTerceiraPorta) : null)
            : zonaOperacaoTerceiraPortaCorte,
          estado: estadoTerceiraPortaCorte,
          ajusteFerramenta: modoOficinaCorte === 'demonstracao' ? ajusteFerramentaPlayerCorte : ajusteFerramentaTerceiraPortaCorte,
          afastamento: modoOficinaCorte === 'demonstracao' ? playerCorte.afastamentoFerramenta : (segurandoFerramentaCorte ? 0 : 0.08),
          ferramentaVisivel: modoOficinaCorte === 'demonstracao' ? playerCorte.ferramentaVisivel : (zonaOperacaoTerceiraPortaCorte !== null),
          preparo: modoOficinaCorte === 'demonstracao' ? playerCorte.preparoFerramenta : 1,
          estadoInicial: modoOficinaCorte === 'demonstracao' ? playerCorte.estadoInicialFerramenta : null,
          deslizar: modoOficinaCorte === 'demonstracao',
          desabilitarArraste: true,
          ...interacaoTerceiraPorta,
        }}
        cinematica={{
          tipoColisao,
          alvoImpacto,
          velocidadeImpacto,
          tempo: timeline.tempo,
          ocupantes,
          idFoco: idFocoCinematica,
          mostrarVetores: sobreposicoes.mostrarVetores,
          mostrarRastros: sobreposicoes.mostrarRastros,
          mostrarEixoColuna: sobreposicoes.mostrarEixoColuna,
          fisicaReal,
          tonus: tonusOcupante,
          estadosPecas: estadosEfetivos,
          aoSelecionarOcupante: setIdFocoCinematica,
          aoResolverFisica: setFisicaCarga,
          trajetoriaFrontal,
          smallOverlap,
          ladoLateral,
          outroVeiculo,
          mostrarMapaDeformacao,
          pausado: !timeline.reproduzindo,
          lataSolida: lataSolidaCinematica,
          pistas: pistasCenaCinematica,
          pistaSelecionadaId,
          aoSelecionarPista: (id) => {
            setPistaSelecionadaId(id)
            if (id && !pistasInspecionadas.includes(id)) {
              setPistasInspecionadas((ant) => [...ant, id])
            }
          },
          mostrarPistas,
        }}
        estabilizacao={{
          montagem: { previa: montagemEstabilizacao.previa, pontosDisponiveis: montagemEstabilizacao.disponiveis, aoEscolherPonto: montagemEstabilizacao.escolher, instrucao: montagemEstabilizacao.visivel ? montagemEstabilizacao.instrucao : undefined },
          posicao: posicaoEstabilizacao,
          equipamentoSelecionado: ferramentaEstabilizacao === 'selecao' ? null : ferramentaEstabilizacao,
          colocacoes: colocacoesEstabilizacao,
          idSelecionado: idColocacaoEstabilizacaoSelecionada,
          avaliacao: avaliacaoEstabilizacao,
          mostrarInstabilidade,
          estadoSuspensao,
          colarCervical,
          aoPosicionar: posicionarEquipamentoEstabilizacao,
          aoSelecionar: setIdColocacaoEstabilizacaoSelecionada,
          aoRemover: removerEquipamentoEstabilizacao,
          aoAtualizarColocacao: atualizarColocacaoEstabilizacao,
          aoPerturbar: perturbarVeiculo,
        }}
        tabletop={{
          objetos: tabletop.cena.objetos,
          idSelecionado: tabletop.idSelecionado,
          ferramenta: tabletop.ferramenta,
          aoSelecionar: tabletop.selecionarNaMesa,
          // em Atender, arrastar uma peça reposiciona o cenário (e não só a cópia da sessão)
          aoTransformar: tabletop.modo === 'atender' ? tabletop.transformarNoCenario : tabletop.transformar,
          aoAlterarManipulacao: tabletop.aoAlterarManipulacao,
          aoCancelarManipulacao: tabletop.cancelarManipulacao,
          encaixeAtivo: encaixeTabletopAtivo,
          exibirAsfalto: tabletop.asfaltoAtivo,
          cenarioTravado: tabletop.cenarioTravado,
          arrastoNaSessao: true,
          pincel: {
            ativo: pincelTabletopAtivo && tabletop.modo === 'montar' && !tabletop.tipoParaPosicionar,
            larguraM: larguraPincelTabletop,
            intrusaoM: intrusaoPincelTabletop,
            aoAplicar: (idVeiculo, ponto) => tabletop.aplicarAmassadoNoPonto(
              idVeiculo, ponto, larguraPincelTabletop, intrusaoPincelTabletop,
            ),
          },
          aoSelecionarPeca: tabletop.selecionarPecaVeiculo,
          somenteLeitura: tabletop.modo === 'atender',
          tipoParaPosicionar: tabletop.tipoParaPosicionar,
          escolhendoAlvo: tabletop.idOlhandoPara !== null,
          // em Atender, posicionar um equipamento é operação da sessão (fica registrada)
          aoPosicionarNovaPeca: tabletop.modo === 'atender'
            ? operacoesSessao.posicionarEquipamento
            : (tipo, x, z, y, rotacao) => tabletop.adicionarNaPosicao(tipo, x, z, encaixeTabletopAtivo, y, rotacao),
          aoVincularVitima: tabletop.vincularVitima,
          aoDesvincularVitima: tabletop.desvincularVitima,
          pedidoTesteBalanco: tabletop.pedidoTesteBalanco,
          // sem isto, o anel de triagem e o colar cervical da cena 3D sempre mostravam
          // o gabarito do instrutor (objeto.vitima.triagem/colarCervical), mesmo no
          // modo aluno — o Atendimento nunca chegava a alcançar a própria maquete
          atendimento: {
            modoExibicao: 'instrutor',
            triagensDeclaradas: atendimentoTabletop.triagensDeclaradas,
            colaresColocados: atendimentoTabletop.colaresColocados,
            // estado da SESSÃO (sangramento, vidro varrido, serragem...) só em Atender:
            // em Montar a cena mostra o cenário preparado, sem resto de aula anterior
            sangramentos: tabletop.modo === 'atender' ? atendimentoTabletop.sangramentos : undefined,
            riscos: tabletop.modo === 'atender' ? atendimentoTabletop.riscos : undefined,
            idVitimaFoco: atendimentoTabletop.sessao.focoVitimaId,
            regiaoDestaque: atendimentoTabletop.sessao.destaqueRegiaoAnatomica,
          },
        }}
        extracao={{
          girarEmBloco,
          eixoColuna: extracao.eixoColuna,
          ancora: extracao.ancora,
          proporcoes: extracao.proporcoes,
          configuracao,
          colocacaoInicial: extracao.colocacaoInicial,
          rota: extracao.rota,
          rotaComparada: extracao.rotaComparada,
          tempo: timeline.tempo,
          comPrancha,
          comMeiaPrancha,
          colarCervical: colarCervical || procedimentosFeitos.includes('colocarColarCervical'),
          mostrarEixoColuna: sobreposicoes.mostrarEixoColuna,
          mostrarTrajetoria: sobreposicoes.mostrarTrajetoria,
          mostrarArco: sobreposicoes.mostrarArco,
          mostrarPosicaoInicial: sobreposicoes.mostrarPosicaoInicial,
          mostrarSetaCervical: sobreposicoes.mostrarSetaCervical,
          orientacaoSeta,
          aoAlterarOrientacaoSeta: setOrientacaoSeta,
          procedimentosFeitos,
          silhuetaBancoAnterior: mostrarPosicaoAnteriorBanco ? extracao.efeitoUltimaAcao?.silhuetaBanco ?? null : null,
          vitimasSecundarias: extracao.vitimasSecundarias,
          idVitimaEmRetirada: idFocoExtracao,
          aoSelecionarVitima: sessaoExtracao.sessao.modo === 'cenario' ? focarVitimaCenario : focarVitimaExtracao,
          veiculosSecundarios: sessaoExtracao.sessao.modo === 'cenario'
            ? (() => {
                const cenarioPedagogico = sessaoExtracao.sessao.cenario
                const vitimaFoco = cenarioPedagogico.vitimas.find((item) => item.id === sessaoExtracao.sessao.vitimaFocoId)
                return cenarioPedagogico.veiculos
                  .filter((veiculo) => veiculo.id !== vitimaFoco?.veiculoId)
                  .map((veiculo) => ({
                    id: veiculo.id,
                    nome: veiculo.nome,
                    configuracao: veiculo.configuracao,
                    decubito: veiculo.decubito ?? 'dorsal' as const,
                    sentidoCabeca: veiculo.sentidoCabeca ?? 'frente' as const,
                    vitimas: cenarioPedagogico.vitimas
                      .filter((item) => item.veiculoId === veiculo.id)
                      .map((item) => ({
                        id: item.id,
                        nome: item.nome,
                        idAncora: item.idAncora,
                        idPerfil: item.idPerfil,
                        estadoClinico: item.estadoClinico,
                      })),
                  }))
              })()
            : [],
          obstaculosExternos,
          ferramenta: ferramentaExtracao,
          direcaoSeta: direcaoSetaExtracao,
          aoAlterarDirecaoSeta: alterarDirecaoSetaExtracao,
          aoIniciarTrajeto: (ponto) => {
            setPontosRotaLivre([ponto])
            timeline.reiniciar()
          },
          aoAdicionarPontoTrajeto: adicionarPontoRota,
          aoPosicionarObstaculo: posicionarObstaculoExterno,
          aoRemoverObstaculo: (id) => setObstaculosExternos((lista) => lista.filter((o) => o.id !== id)),
          aprisionamentos: aprisionamentosVisiveis(sessaoExtracao.sessao),
          achadosDestacados: achadosComRegiaoVisiveis(sessaoExtracao.sessao),
        }}
        vidros={{
          vidroSelecionado,
          estadosVidros,
          protecoes: protecoesVidros,
          temInsulfilm,
          detritosNaVitima,
          detritosNasProtecoes,
          peliculaNoSolo,
          aoSelecionarVidro: setVidroSelecionado,
          animacaoAtiva: animacaoVidroAtiva,
          aoFinalizarAnimacao: () => setAnimacaoVidroAtiva(null),
        }}
      />

      <div className="badge-prototipo">
        {aba === 'tabletop' ? `Table top livre • ${tabletop.cena.objetos.length} objeto(s)` : `Estrutura veicular 3D • ${perfil.nome}`}
      </div>
      {aba === 'tabletop' && persistenciaSessao.sessaoPendente && (
        <div className="tt-banner-sessao" role="status">
          <span>
            Há uma sessão de atendimento salva — <strong>{persistenciaSessao.sessaoPendente.nomeCena}</strong>,{' '}
            {formatarTempoAula(persistenciaSessao.sessaoPendente.tempoSimuladoSegundos)} de aula, salva às{' '}
            {new Date(persistenciaSessao.sessaoPendente.salvoEm).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}.
          </span>
          <button type="button" className="btn-acao-cad btn-acao-cad--destaque" onClick={persistenciaSessao.retomar}>
            Retomar
          </button>
          <button type="button" className="btn-acao-cad btn-acao-cad--secundario" onClick={persistenciaSessao.descartar}>
            Descartar
          </button>
        </div>
      )}
      {aba === 'tabletop' && tabletop.idOlhandoPara ? (
        <div className="tt-banner-posicionamento">
          Clique em um carro ou vítima para virar o socorrista para esse ponto.
          <button type="button" onClick={tabletop.cancelarOlharPara}>Cancelar</button>
        </div>
      ) : aba === 'tabletop' && tabletop.tipoParaPosicionar ? (
        <div className="tt-banner-posicionamento">
          Toque no chão para posicionar {CATALOGO_TABLETOP.find((i) => i.tipo === tabletop.tipoParaPosicionar)?.rotulo ?? 'a peça'}
          <button type="button" onClick={tabletop.cancelarPosicionamento}>
            Cancelar
          </button>
        </div>
      ) : aba === 'tabletop' && tabletop.modo === 'montar' && tabletop.objetoSelecionado ? (
        <BarraAcaoRapidaSelecao
          objeto={tabletop.objetoSelecionado}
          onGirar90={() => tabletop.girar(tabletop.objetoSelecionado!.id, 90)}
          onGirar={(delta) => tabletop.girar(tabletop.objetoSelecionado!.id, delta)}
          onDefinirDirecao={(graus) => tabletop.definirDirecao(tabletop.objetoSelecionado!.id, graus)}
          onIniciarDirecao={() => tabletop.aoAlterarManipulacao(true)}
          onFinalizarDirecao={() => tabletop.aoAlterarManipulacao(false)}
          onOlharPara={() => tabletop.iniciarOlharPara(tabletop.objetoSelecionado!.id)}
          bloqueioCenario={tabletop.cenarioTravado}
          onDuplicar={() => tabletop.duplicar(tabletop.objetoSelecionado!.id)}
          onAlternarBloqueio={() =>
            tabletop.alternarBloqueio(tabletop.objetoSelecionado!.id, !tabletop.objetoSelecionado!.bloqueado)
          }
          onAlternarOculto={() => {
            const id = tabletop.objetoSelecionado!.id
            tabletop.alternarOculto(id, !tabletop.objetoSelecionado!.oculto)
            // uma peça oculta não tem mais o que essa barra flutuante apontar
            tabletop.selecionar(null)
          }}
          onRemover={() => tabletop.remover(tabletop.objetoSelecionado!.id)}
          onAbrirEditor={() => setGrupoRibbonAtivo('editor')}
          onAbrirFichaClinica={tabletop.objetoSelecionado.tipo === 'vitima' ? () => {
            setSecaoTabletop('vitima'); setInspetorRecolhido(false); setGrupoRibbonAtivo(modoLayout === 'mobile' ? 'vitima' : null)
          } : undefined}
          onTestarEstabilidade={
            tabletop.objetoSelecionado.veiculo?.posicaoFinal === 'sobreRodas'
              ? () => tabletop.testarBalanco(tabletop.objetoSelecionado!.id)
              : undefined
          }
        />
      ) : (
        <div className="ajuda-camera">
          {aba === 'tabletop'
              ? 'Toque para selecionar • segure e arraste para mover • arraste o chão para girar a cena'
            : 'Arraste para orbitar • scroll/pinça para zoom • toque na peça para inspecionar'}
        </div>
      )}
        </>
          )
      }
      trilha={
        mostrarCenaGuiada || modoLayout === 'mobile' || (aba === 'extracao' && areaExtracao === 'oficina') ? undefined : (
          <TrilhaFerramentas
            camera={{
              executar: (tipo) => camera.executar(tipo, idSelecionado),
              vistaAtiva: camera.vistaAtiva,
            }}
            temSelecao={idSelecionado != null}
            historico={historicoDoModulo}
            motivoSemHistorico="A cinemática não tem edição a desfazer: os parâmetros do evento são reversíveis pelos próprios controles"
            modoLayout={modoLayout}
            gruposExtrasNoTopo={aba === 'estabilizacao' || (aba === 'tabletop' && secaoTabletop === 'estabilizacao') || (aba === 'corte' && modoOficinaCorte === 'pratica')}
            gruposExtras={
              aba === 'tabletop' && secaoTabletop === 'estabilizacao'
                ? [{
                    id: 'ferramentas-estabilizacao-tabletop', rotulo: 'Equipamentos de estabilização',
                    ferramentas: [
                      { id: 'selecao-tabletop', rotulo: 'Ponteiro / Selecionar', atalho: 'V', Icone: IconeSelecao, ativa: tabletop.tipoParaPosicionar == null, aoAcionar: () => tabletop.cancelarPosicionamento() },
                      ...([
                        ['calco', 'Calço escalonado', '1', IconeCalco], ['bloco', 'Bloco', '2', IconeBloco],
                        ['cunha', 'Cunha de resgate', '3', IconeCunha], ['fitaCatraca', 'Fita catraca', '4', IconeFitaCatraca],
                        ['vstrut', 'V-Strut', '5', IconeVStrut],
                      ] as const).map(([tipo, rotulo, atalho, Icone]) => ({
                        id: `tabletop-${tipo}`, rotulo, atalho, Icone,
                        ativa: tabletop.tipoParaPosicionar === tipo,
                        motivoIndisponivel: tabletop.cena.objetos.some(o => o.veiculo) ? undefined : 'Adicione um veículo antes de posicionar equipamentos',
                        aoAcionar: () => iniciarEquipamentoTabletop(tipo),
                      })),
                    ],
                  }]
                : aba === 'estabilizacao'
                ? gruposExtrasEstabilizacao
                : aba === 'corte' && modoOficinaCorte === 'pratica'
                ? gruposDaCaixaDeFerramentasCorte
                : aba === 'extracao'
                ? [
                    {
                      id: 'enquadramentos-extracao',
                      rotulo: 'Enquadramentos da extração',
                      ferramentas: [
                        {
                          id: 'interiorExtracao',
                          rotulo: 'Interior',
                          Icone: IconeInteriorExtracao,
                          aoAcionar: () => camera.executar('interiorExtracao'),
                        },
                        {
                          id: 'alinhamentoVitimaPrancha',
                          rotulo: 'Alinhamento vítima–prancha',
                          Icone: IconeAlinhamentoVitimaPrancha,
                          aoAcionar: () => camera.executar('alinhamentoVitimaPrancha', idFocoExtracao),
                        },
                        {
                          id: 'voltarEnquadramento',
                          rotulo: 'Voltar ao enquadramento anterior',
                          Icone: IconeVoltarEnquadramento,
                          aoAcionar: () => camera.executar('voltarEnquadramento'),
                        },
                      ],
                    },
                  ]
                : undefined
            }
          />
        )
      }
      dockCamera={
        mostrarCenaGuiada || (aba === 'extracao' && areaExtracao === 'oficina') ? undefined : (
        <DockCamera3D
          camera={camera}
          temSelecao={selecionada != null}
          modoLayout={modoLayout}
          comEnquadrarCena={aba === 'tabletop'}
        />
        )
      }
      inspetor={
        modoLayout === 'mobile' || aba === 'cinematica' || mostrarOficinaVitimas ? undefined : (
          <InspetorCAD
            tituloModulo={TITULOS[aba]}
            modoLayout={modoLayout}
            recolhido={inspetorRecolhido}
            aoAlternarRecolhido={() => setInspetorRecolhido((v) => !v)}
            abaAtiva={abaInspetorCAD}
            aoTrocarAba={setAbaInspetorCAD}
            somenteOperacao={aba === 'tabletop'}
            somentePropriedades={aba === 'maquete'}
            conteudoPropriedades={ferramentas.inspetor ?? null}
            conteudoOperacao={
              aba === 'estabilizacao' && montagemEstabilizacao.visivel
                ? <PainelMontagemEstabilizacao montagem={montagemEstabilizacao} />
                : aba === 'tabletop'
                ? renderRoteiroAula(secaoTabletop)
                : aba === 'extracao' ? (
                <>
                  {renderPainelExtracao(['posicao', 'rota'])}
                </>
              ) : undefined
            }
            conteudoChecklist={
              aba === 'extracao' ? (
                <>
                  {renderPainelExtracao(['obstaculos'])}
                </>
              ) : undefined
            }
            guiaRapido={
              aba === 'extracao' ? (
                <GuiaRapidoExtracao
                  faseAtual={faseAnimacaoExtracao}
                  configuracao={configuracao}
                  comPrancha={comPrancha}
                  aoPularParaFase={(t) => {
                    timeline.irPara(t)
                  }}
                  colarColocado={colarCervical || procedimentosFeitos.includes('colocarColarCervical')}
                  portasAbertas={timeline.tempo > 0.08}
                  pranchaInserida={timeline.tempo > 0.55}
                />
              ) : undefined
            }
            aoLimparSelecao={() => setSelecionada(null)}
          />
        )
      }
      barraEstado={mostrarOficinaVitimas ? undefined : <BarraEstado itens={mostrarQuatroImpactos ? [{ id: 'aula-impactos', rotulo: 'Cinemática', valor: 'Quatro impactos · reprodução na cena' }] : itensEstado} />}
      logs={
        aba === 'extracao' && !mostrarOficinaVitimas && sessaoExtracao.sessao.modo === 'cenario' ? (
          <CentralLogs
            registros={registrosDecisaoExtracao}
            tempo={1}
            sessao={`extracao::${sessaoExtracao.sessao.cenario.id}`}
            aoIrPara={irParaDecisaoExtracao}
          />
        ) : undefined
      }
      rodape={
        <footer className="aviso">
          Apoio a treinamento. Não substitui doutrina, instrutor nem protocolo operacional.
          <span className="aviso__direitos">{' · '}© 2026 Marco Guerra. Todos os direitos reservados.</span>
          <span className="aviso__creditos">
            {' · '}Desenvolvido por{' '}
            <a
              href="https://marcoguerra.dev.br"
              target="_blank"
              rel="noreferrer"
              className="marca-digital-bricks"
            >
              <img
                src="/marco-guerra.png"
                alt=""
                aria-hidden="true"
                className="marca-digital-bricks__logo"
              />
              <span>Marco Guerra</span>
            </a>
          </span>
        </footer>
      }
    />
  )
}
